<template lang="html">
    <vue100vh style="position: fixed !important; width: 100% !important; overflow: hidden !important; height: 100vh !important;">
<!-- <div style="position: fixed; width: 100%; overflow: hidden; background-color: white; height: 100vh;"> -->
        <div :style="stylechat">
            <v-toolbar class="toolbar-header-user" v-if="statusForward">
                <v-row wrap class="justify-center align-center">
                  <p class="HeaderName mb-0">{{$t('Dialog.forward.selectmessage')}}</p>
                </v-row>
            </v-toolbar>
            <v-toolbar class="toolbar-header-user" v-else>
                <v-btn dark icon @click="backpage()" v-if="backstatus !== 'false'">
                    <v-icon class="icon-color fz-30">mdi-chevron-left</v-icon>
                </v-btn>
                <v-avatar
                  size="35"
                >
                  <img v-if="pictureRoom" :src="pictureRoom" class="imgProfilechat pictureRoomChat alligator-turtle" />
                </v-avatar>
                <p class="HeaderName text-overflow mb-0" v-if="typeRoom !== 'group'">{{nameRoom}}</p>
                <p class="HeaderName text-overflow-group mb-0" v-else>{{nameRoom}}</p>
                <p class="HeaderName mb-0" v-if="typeRoom === 'group'">({{detialroom.count_member}})</p>
                <v-spacer></v-spacer>
                <v-icon class="icon-color fz-20" v-if="showmenu" @click="showMenu(true)">fa-solid fa-bars</v-icon>
            </v-toolbar>
            <div>
                <div id="myModalImage" class="modalc">
                    <div id="headcaption">
                        <v-container>
                            <v-layout row wrap>
                                <v-flex xs12 md12 sm12 style="text-align: right; padding: 10px 10px 10px 20px;">
                                    <span class="close" style="cursor: pointer;font-size: 30px;" @click="closemodal()">&times;</span>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </div>
                    <img class="modal-contentc" id="img01">
                </div>
                <!-- modal video -->
                <div id="myModalVideo" class="modalc">
                    <div id="headcaption">
                        <v-container>
                            <v-layout row wrap>
                                <v-flex xs12 md12 sm12 style="text-align: right; padding: 10px 10px 10px 20px;">
                                    <span class="close" style="cursor: pointer;font-size: 30px;" @click="closemodal()">&times;</span>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </div>
                    <video-player class="video-js" :options="videoOptions" :poster="thumbnail_video" ref="myPlayer" :sources="sources_video" />
                </div>
                <div id="myModalpdf" class="modalc">
                    <div id="headcaption">
                        <v-container>
                            <v-layout row wrap justify-start align-center>
                                <v-flex xs12 md12 sm12 style="text-align: right;  padding: 10px 10px 10px 20px;">
                                    <!-- <v-btn v-if="urlpdf" depressed small style="margin-right: 25px;" class="btnallow CSChatThai" id="btn-download" @click="downloadFile(urlpdf,filenamepdf)">
                                        <v-icon>mdi-download</v-icon>&nbsp; {{$t('AnswerQuestion.download')}}
                                    </v-btn> -->
                                    <span class="close" style="cursor: pointer;font-size: 30px;" @click="closemodal()">&times;</span>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </div>
                    <div>
                        <!-- <div style="overflow-y: scroll; height: 80vh;">
                            <div class="app-content">
                              <vue-pdf-embed
                                ref="myPdfComponent"
                                :source="urlpdf"
                                :page="page"
                                @password-requested="handlePasswordRequest"
                                @rendered="handleDocumentRender"
                              />
                            </div>
                        </div> -->
                        <vue-pdf-app :pdf="urlpdf" style="height: 80vh;" :page-number="1"></vue-pdf-app>
                    </div>
                </div>
                <!-- tab announce -->
                <div v-if="list_announce.length !== 0">
                  <v-btn fab dark small class="btn-announce div-announce" v-if="less" @click="less = !less; show = false;">
                    <v-icon dark>fa-solid fa-bullhorn</v-icon>
                  </v-btn>

                  <v-card style="position: fixed; width: 100%; z-index: 2; background: none;" v-else id="list_height">
                    <v-slide-y-transition>
                      <v-card-text v-show="show" style="padding: 0px !important;">
                        <v-list style="max-height: 200px; overflow-y: scroll;">
                          <template v-for="(item, index) in list_announce">
                            <v-list-item
                              :key="`${index}-${item.tokenmessage}`"
                              class="list-announce"
                              v-touch="{
                                left: () => swipe('Left', index),
                                right: () => swipe('Right', index)
                              }"
                              >
                              <v-list-item-action>
                                <v-icon style="font-size: 18px;">fas fa-bullhorn</v-icon>
                              </v-list-item-action>
                              <v-list-item-content @click="gotoMessageReply(item.tokenmessage, '')">
                                <v-list-item-title style="font-size: 13px;" v-html="convert(item.message_info.message, item.message_info)"></v-list-item-title>
                                <v-list-item-subtitle style="font-size: 12px;">{{ item.nickname }}</v-list-item-subtitle>
                              </v-list-item-content>

                              <v-list-item-action v-if="swipe_state === 'Left' && swipe_index === index">
                                <v-row justify="center" align="center">
                                  <!-- <v-col @click="cancleAnnounceId(item._id, index)" cols="6" justify="center" align="center" class="bg-list-swipe-pin">
                                    <span>{{$t('ChatSide.RightClickMenu.cancelAnnounce')}}</span>
                                  </v-col> -->
                                  <v-col @click="deleteAnnounceId(item._id, index)" cols="12" justify="center" align="center" class="bg-list-swipe-unpin">
                                    <span>{{$t('ChatSide.RightClickMenu.deleteAnnounce')}}</span>
                                  </v-col>
                                </v-row>
                              </v-list-item-action>
                            </v-list-item>
                            <v-divider v-if="index + 1 < list_announce.length" :key="index"></v-divider>
                          </template>
                        </v-list>
                      </v-card-text>
                    </v-slide-y-transition>
                    <v-card-actions v-if="!show" style="background: #2562afa6; height: 40px;">
                      <v-icon style="font-size: 18px; color: #1b232c;">fas fa-bullhorn</v-icon>
                      <p class="mb-0" style="color: black; padding-left: 20px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; width: 100%; cursor: pointer; font-size: 13px;"
                         @click="gotoMessageReply(item.tokenmessage, '')" v-html="convert(list_announce[0].message_info.message, list_announce[0].message_info)">
                      </p>
                      <!-- @click="RightClickDialog($event, ['cancel_announce'], listannounce[0])" -->
                      <v-spacer></v-spacer>
                      <v-btn icon @click.native="show = !show">
                        <v-icon>fa-solid fa-angle-down</v-icon>
                      </v-btn>
                    </v-card-actions>
                    <v-card-actions v-if="show" style="color: white;background: #2562af;height: 40px;">
                      <p class="p-announce" @click="delete_announce()">{{$t('ChatSide.announce.delete')}}</p>
                      |
                      <p class="p-announce" @click="less = !less">{{$t('ChatSide.announce.minimize')}}</p>
                      <v-spacer></v-spacer>
                      <v-btn icon @click.native="show = !show">
                        <v-icon style="color: white;">fa-solid fa-angle-up</v-icon>
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </div>

                <div class="chat-container" ref="chatContainer" @scroll="onScroll" :style="scrollable">
                  <!-- @click="InputFocusCancel" -->
                    <div class="message" v-for="(msg,index) in listchat" :key="index" :class="{own: msg.tokenuser === tokenuser}" :id="msg.uid">
                        <div class="systemDateNonMGT CSChatThai pl-2 pr-2" style="text-align: center;" v-if="index == 0">
                            <span>{{dateMoment(msg.timestamp)}}</span>
                        </div>
                        <div class="systemDate CSChatThai pl-2 pr-2" style="text-align: center;" v-else-if="dateMoment(listchat[index-1].timestamp) != dateMoment(msg.timestamp)">
                            <span>{{dateMoment(msg.timestamp)}}</span>
                        </div>



                        <div v-if="msg.tokenuser !== tokenuser">
                            <div v-if="index == 0">
                                <div class="username CSChatThai" v-if="msg.typeofmessage !== 'unsend_message' && msg.typeofmessage !== 'system_action' && msg.typeofmessage !== 'system' && msg.typeofmessage !== 'system_action_albums' && msg.typeofmessage !== 'system_action_task'">
                                  <v-row justify="start" class="mb-2 mt-2">
                                    <v-avatar
                                      size="40"
                                      @click="openDialog(msg, 'detailfriend')"
                                    >
                                    <img v-if="msg.path_pic" :src="msg.path_pic" class="imgProfilechat pictureRoomChat alligator-turtle" />
                                    <img v-else-if="msg.type === 'bot'" :src="`${publicPath}/assets/img/default_profile/bot-white.png`" class="imgProfilechat pictureRoomChat alligator-turtle">
                                    <img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`" class="imgProfilechat pictureRoomChat alligator-turtle">
                                    </v-avatar>
                                    <p class="text-overflow mb-0 pl-3">{{msg.nickname}}</p>
                                  </v-row>
                                </div>
                            </div>
                            <div v-else-if="(listchat[index-1].tokenuser == tokenuser) || (dateMoment(msg.timestamp) != dateMoment(listchat[index-1].timestamp))">
                                <div class="username CSChatThai" v-if="msg.typeofmessage !== 'unsend_message' && msg.typeofmessage !== 'system_action' && msg.typeofmessage !== 'system' && msg.typeofmessage !== 'system_action_albums' && msg.typeofmessage !== 'system_action_task'">
                                  <v-row justify="start" class="mb-2 mt-2">
                                    <v-avatar
                                      size="40"
                                      @click="openDialog(msg, 'detailfriend')"
                                    >
                                    <img v-if="msg.path_pic" :src="msg.path_pic" class="imgProfilechat pictureRoomChat alligator-turtle" />
                                    <img v-else-if="msg.type === 'bot'" :src="`${publicPath}/assets/img/default_profile/bot-white.png`" class="imgProfilechat pictureRoomChat alligator-turtle">
                                    <img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`" class="imgProfilechat pictureRoomChat alligator-turtle">
                                    </v-avatar>
                                    <p class="text-overflow mb-0 pl-3">{{msg.nickname}}</p>
                                  </v-row>
                                </div>
                            </div>
                        </div>
                        <span v-else-if="msg.tokenuser == tokenuser && msg.typeofmessage !== 'unsend_message' && msg.typeofmessage !== 'system_action' && msg.typeofmessage !== 'system' && msg.typeofmessage !== 'system_action_albums' && msg.typeofmessage !== 'system_action_task'" class="pr-2" style="font-size: 9px; color: #424242b3;display: inline-block;">
                          <v-col @click="msg.tokenuser == tokenuser ? messageMenu(msg, ['download', 'cancel', 'mention', 'forward']) : messageMenu(msg, ['download', 'mention', 'forward'])" cols="12" class="pa-0 mb-2" justify="end" v-if="msg.typeofmessage == 'file' && extension(msg.message) == 'audio' && !statusForward">
                            <v-icon class="fz-18">fa-solid fa-arrow-up-from-bracket</v-icon>
                          </v-col>
                          <v-col cols="12" class="pa-0" justify="end">
                            <span>{{timeMoment(msg.timestamp)}}</span>
                          </v-col>
                        </span>

                        <!-- check box forward message -->
                        <div class="checkbox-content" v-if="statusForward">
                          <v-checkbox
                            v-model="selectedForward"
                            :value="msg.tokenmessage"
                            v-if="(msg.typeofmessage === 'message' ||
                            msg.typeofmessage == 'image' ||
                            msg.typeofmessage === 'file' ||
                            msg.typeofmessage === 'pdf_password' ||
                            msg.typeofmessage === 'video' ||
                            msg.typeofmessage === 'location')"
                            >
                          </v-checkbox>
                        </div>
                        <div class="content CSChatThai" v-if="msg.typeofmessage == 'message'" :id="msg.tokenmessage">
                            <div 
                              v-html="convert(msg.message, msg).replace(/(?:\r\n|\r|\n)/g, '<br>')" 
                              @touchend="handleClick"
                              @touchstart="msg.tokenuser == tokenuser ? messageMenu(msg, ['cancel', 'mention', 'forward', 'announce']) : messageMenu(msg, ['mention', 'forward', 'announce'])"
                              >
                              <!-- data-long-press-delay="500" v-longclick="() =>  msg.tokenuser == tokenuser ? messageMenu(msg, ['cancel', 'mention', 'forward', 'announce'], $event) : messageMenu(msg, ['mention', 'forward', 'announce'], $event)" -->
                          </div>

                            <div v-for="x in convertURL(msg.message)" v-if="convertURL(msg.message)">
                              <link-prevue :url="x">
                                <template slot-scope="props">
                                  <v-layout row wrap style="margin-top: 10px;" @click="clicklink_website(props.url)">
                                    <v-flex xl3 lg3 md3 sm3 class="border_website">
                                      <p class="title_website" >{{props.title}}  </p>
                                      <span class="description_website">{{props.description}}</span>
                                    </v-flex>
                                    <v-flex xl9 lg9 md9 sm9 class="centerimg_website">
                                      <img class="img_website" :src="props.img"  v-if="props.img">
                                    </v-flex>
                                  </v-layout>
                                </template>
                                <template slot="loading">
                                  <span></span>
                                </template>
                              </link-prevue>
                           </div>
                        </div>
                        <div class="systemDate CSChatThai pl-2 pr-2" style="text-align: center;" v-else-if="msg.typeofmessage == 'unsend_message'" :id="msg.tokenmessage">
                            <span v-if="msg.tokenuser === tokenuser">{{$t('ChatSide.system.self.cancelMsg')}}</span>
                            <span v-else>{{$t('ChatSide.system.other.cancelMsg', { name: msg.nickname})}}</span>
                        </div>
                        <div class="systemDate CSChatThai pl-3 pr-3 pb-2" style="text-align: center;" v-else-if="msg.typeofmessage == 'system'" :id="msg.tokenmessage">
                            <span>{{msg.message}}</span>
                        </div>
                        <div class="systemDate CSChatThai pl-3 pr-3 pb-2" style="text-align: center;"
                          v-else-if="msg.typeofmessage == 'system_action_task'" :id="msg.tokenmessage">
                          <span class="boxself_system" v-if="msg.message === 'edit_task'">
                            {{ $t('ChatSide.system.self.editTask') }}
                          </span>
                          <span class="boxself_system" v-if="msg.message === 'create_project'">
                            {{ $t('ChatSide.system.self.createProject') }}
                          </span>
                        </div>
                        <div class="systemDate CSChatThai pl-3 pr-3 pb-2" style="text-align: center;" v-else-if="msg.typeofmessage == 'system_action_albums'" :id="msg.tokenmessage">
                            <p class="boxself_unsend mb-0" v-if="msg.message == 'edit_name_albums'">
                              {{$t('ChatSide.system.self.editNameAlbum')}}
                            </p>
                            <p class="boxself_unsend mb-0" v-else-if="msg.message == 'create_albums'">
                              {{$t('ChatSide.system.self.createAlbum',{name: msg.albums_name})}}
                            </p>
                            <p class="boxself_unsend mb-0" v-else-if="msg.message == 'delete_albums'">
                              {{$t('ChatSide.system.self.deleteAlbum')}}
                            </p>
                            <p class="boxself_unsend mb-0" v-else-if="msg.message == 'delete_images_albums'">
                              {{$t('ChatSide.system.self.deleteImageAlbum')}}
                            </p>
                        </div>
                        <div class="systemDate CSChatThai pl-3 pr-3 pb-2" style="text-align: center;" v-else-if="msg.typeofmessage == 'system_action'" :id="msg.tokenmessage">
                          <span class="boxself_system" v-if="msg.message === 'active'">
                            <span>{{timeMoment(msg.timestamp)}}</span>
                            <br>
                            <span v-if="msg.tokenuser === tokenuser">{{$t('ChatSide.system.self.joinGroup')}}</span>
                            <span v-else>{{$t('ChatSide.system.other.joinGroup', { name: msg.file_name })}}</span>
                          </span>
                          <span class="boxself_system" v-else-if="msg.message === 'kick'">
                            <span>{{timeMoment(msg.timestamp)}}</span>
                            <br>
                            {{$t('ChatSide.system.default.kickMemberGroup', { name_active: msg.nickname, name_passive: msg.file_name})}}
                          </span>
                          <span class="boxself_system" v-else-if="msg.message === 'invite'">
                            <span>{{timeMoment(msg.timestamp)}}</span>
                            <br>
                            {{$t('ChatSide.system.default.inviteMemberGroup', { name_active: msg.nickname, name_passive: msg.file_name})}}
                          </span>
                          <span class="boxself_system" v-else-if="msg.message === 'leave'">
                            <span>{{timeMoment(msg.timestamp)}}</span>
                            <br>
                            <!-- ออกจากกลุ่ม. -->
                            <span v-if="msg.tokenuser === tokenuser">{{$t('ChatSide.system.self.leftGroup')}}</span>
                            <span v-else>{{$t('ChatSide.system.other.leftGroup', { name: msg.file_name })}}</span>
                          </span>
                        </div>
                        <div class="contentimage CSChatThai" v-else-if="msg.typeofmessage == 'image'" :id="msg.tokenmessage" @click="msg.tokenuser == tokenuser ? messageMenu(msg, ['image', 'download', 'cancel', 'mention', 'forward', 'album','onebox', 'mail']) : messageMenu(msg, ['image', 'download', 'mention', 'forward', 'album','onebox', 'mail'])">
                          <!-- @click="zoom(msg)" -->
                            <img :src="msg.message" style="max-height: 150px;max-width: 60vw;cursor: pointer;" :id="msg._id" />
                        </div>
                        <div class="contentimage CSChatThai" v-else-if="msg.typeofmessage == 'sticker'" :id="msg.tokenmessage" @click="msg.tokenuser == tokenuser ? messageMenu(msg, ['cancel', 'mention']) : messageMenu(msg, ['mention'])">
                            <img :src="msg.file_name" style="max-height: 150px;max-width: 60vw;cursor: pointer;" :id="msg._id" />
                        </div>
                        <div class="contentlocation CSChatThai" v-else-if="msg.typeofmessage == 'location'" :id="msg.tokenmessage" @click="msg.tokenuser == tokenuser ? messageMenu(msg, ['openmap', 'cancel', 'mention', 'forward']) : messageMenu(msg, ['openmap', 'mention', 'forward'])">
                          <v-layout class="ma-1">
                              <v-flex xs3 xl3 md3 sm3 lg3>
                                <v-layout column wrap justify-center align-start style="height: 100%;">
                                  <v-icon :style="msg.tokenuser === tokenuser ? 'font-size: 24px; color: white;': 'font-size: 30px; color: #34567f;'">fa-solid fa-location-dot</v-icon>
                                </v-layout>
                              </v-flex>
                              <v-flex xs9 xl9 md9 sm9 lg9 class="pl-1">
                                <span v-if="msg.file_name !== ''"> {{msg.file_name}}</span>
                                <span v-else>  {{$t('ChatSide.location')}}</span>
                              </v-flex>
                          </v-layout>
                        </div>
                        <div class="contentcontact CSChatThai mt-1 " v-else-if="msg.typeofmessage == 'contact'" :id="msg.tokenmessage" @click="searchContact(msg)">
                          <v-layout class="ma-1">
                              <v-flex xs2 xl2 md2 sm2 lg2>
                                <v-layout column wrap justify-center align-start style="height: 100%;">
                                  <v-avatar
                                    size="40"
                                  >
                                  <img v-if="msg.pic_contact" :src="msg.pic_contact" class="imgProfilechat pictureRoomChat alligator-turtle" />
                                  <img v-else-if="msg.type_contact === 'bot'" :src="`${publicPath}/assets/img/default_profile/bot-white.png`" class="imgProfilechat pictureRoomChat alligator-turtle">
                                  <img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`" class="imgProfilechat pictureRoomChat alligator-turtle">
                                  </v-avatar>
                                </v-layout>
                              </v-flex>
                              <v-flex xs10 xl10 md10 sm10 lg10 class="pl-5">
                                <v-layout row wrap justify-center align-center style="height: 100%;" class="pl-2 pt-5">
                                  <b class="text-overflow-contact">{{msg.nickname_contact}}</b>
                                  <v-spacer></v-spacer>
                                  <v-icon class="iconContact">fa-solid fa-angle-right</v-icon>
                                </v-layout>
                              </v-flex>
                              <!-- <v-flex xs2 xl2 md2 sm2 lg2>
                                <v-layout column wrap justify-center align-start style="height: 100%;">
                                  <v-icon class="iconContact">fa-solid fa-angle-right</v-icon>
                                </v-layout>
                              </v-flex> -->
                          </v-layout>
                        </div>
                        <div class="contentfile CSChatThai" v-else-if="(msg.typeofmessage == 'file' || msg.typeofmessage == 'password_file') && extension(msg.message) === 'fas fa-file-alt'" :id="msg.tokenmessage"
                          @click="msg.tokenuser == tokenuser ? messageMenu(msg, ['file', 'download', 'cancel', 'mention', 'forward', 'onebox', 'mail']) : messageMenu(msg, ['file', 'download', 'mention', 'forward', 'onebox', 'mail'])"
                        >
                            <v-layout class="ma-1">
                                <v-flex xs3 xl3 md3 sm3 lg3>
                                  <v-layout row wrap justify-center align-center class="pt-2 pb-2">
                                    <v-icon class="iconFile">fas fa-file-pdf</v-icon>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs9 xl9 md9 sm9 lg9>
                                    <p class="wrap-file pl-2 mb-0">{{msg.file_name}}</p>
                                </v-flex>
                            </v-layout>
                        </div>
                        <div class="contentfile CSChatThai" v-else-if="msg.typeofmessage == 'file' && extension(msg.file_name) !== 'audio'" :id="msg.tokenmessage"
                          @click="msg.tokenuser == tokenuser ? messageMenu(msg, ['download', 'cancel', 'mention', 'forward', 'onebox', 'mail']) : messageMenu(msg, ['download', 'mention', 'forward', 'onebox', 'mail'])"
                        >
                            <v-layout class="ma-1">
                                <v-flex xs3 xl3 md3 sm3 lg3>
                                  <v-layout row wrap justify-center align-center class="pt-2 pb-2">
                                    <v-icon class="iconFile">{{extension(msg.message)}}</v-icon>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs9 xl9 md9 sm9 lg9>
                                    <p class="wrap-file pl-2 mb-0">{{msg.file_name}}</p>
                                </v-flex>
                            </v-layout>
                        </div>
                        <!-- audio -->
                        <div class="contentimage CSChatThai mr-2" v-else-if="msg.typeofmessage == 'file' && extension(msg.file_name) === 'audio'" :id="msg.tokenmessage"
                          @click="msg.tokenuser == tokenuser ? messageMenu(msg, ['download', 'cancel', 'mention', 'forward', 'onebox']) : messageMenu(msg, ['download', 'mention', 'forward', 'onebox'])"
                        >
                            <div style="min-width: 60vw; justify-content: start; align-items: start; z-index: 0; margin-top: 10px; display: flex;"
                            >
                              <!-- <aplayer
                                style="z-index: 0; padding-right: 20px; padding-bottom: 10px; padding-top: 10px;"
                                :playerOptions="{
                                  type: 'application/x-mpegURL',
                                  src: msg.message,
                                  preload: true,
                                  autoplay: false,
                                  isLoop: false,
                                  playsinline: false,
                                  controls: 'progress, current, durration',
                                  crossOrigin: false
                                }"
                                @onplay="play"
                                @onerror="onerrorAudio($event)"
                                @onprogress="onprogressAudio"
                              /> -->
                              <audio controls style="border-radius: 10px;">
                                <source :src="msg.message" :type="'audio/' + msg.file_name.split('.')[msg.file_name.split('.').length - 1]">
                              </audio>
                            </div>
                        </div>
                        <div class="contentimage CSChatThai" v-else-if="msg.typeofmessage == 'video'" :id="msg.tokenmessage"
                        @click="msg.tokenuser == tokenuser ? messageMenu(msg, ['video', 'download', 'cancel', 'mention', 'forward']) : messageMenu(msg, ['video', 'download', 'mention', 'forward'])">
                          <div style="max-width: 60vw; max-height: 150px; justify-content: center; align-items: center; z-index: 0; margin-top: 10px;">
                            <v-img :src="msg.thumbnail" :id="msg.tokenmessage">
                              <template>
                                <v-row
                                  class="fill-height ma-0"
                                  align="center"
                                  justify="center"
                                >
                                  <v-icon class="iconFile fz-60">fa-solid fa-circle-play</v-icon>
                                </v-row>
                              </template>
                            </v-img>
                          </div>
                        </div>
                        <!-- albums message -->
                        <div class="content CSChatThai"
                          v-else-if="msg.typeofmessage === 'albums_message'" @click="openDialog(msg, 'albums')">
                          <v-row justify="start" align="center" class="pl-3 pt-2 pb-1">
                            <p v-if="msg.message === 'create_albums'" class="mb-0">{{
                              $t('ChatSide.Album.createAlbumHeader') }}</p>
                            <p v-else-if="msg.message === 'addimage_albums'" class="mb-0">{{
                              $t('ChatSide.Album.insertImageAlbum', {
                                name:
                                  msg.albums_name
                              }) }}</p>
                          </v-row>
                          <v-row class="justify-center align-center pa-4" v-if="msg.image_add.length !== 0">
                            <v-col class="pa-0" cols="6" v-for="(item, index) in msg.image_add" :key="index">
                              <v-img v-if="index < 4" :src="item.link" :lazy-src="item.link"
                                aspect-ratio="1"></v-img>
                            </v-col>
                          </v-row>
                          <v-row justify="start" align="center" class="pl-3 pt-2 pb-1" v-if="msg.image_add.length !== 0">
                            <span>{{ $t('ChatSide.Album.numberImage', { count: msg.image_add.length }) }}</span>
                          </v-row>
                          <v-divider class="mt-2 color-divider"></v-divider>
                          <v-row justify="start" class="mt-2 pl-3 pr-2 pb-1">
                            <span>{{ msg.albums_name }}</span>
                            <v-spacer></v-spacer>
                            <v-icon class="iconnote">mdi-chevron-right</v-icon>
                          </v-row>
                        </div>
                        <div class="content CSChatThai" v-else-if="msg.typeofmessage === 'date'" :id="msg.tokenmessage">
                          <v-icon style="font-size: 16px; color: white;">far fa-calendar-alt</v-icon>
                          &nbsp; {{momentday(msg.message)}}
                        </div>
                        <div class="content CSChatThai" v-else-if="msg.typeofmessage === 'datetime'" :id="msg.tokenmessage">
                          <v-icon style="font-size: 16px; color: white;">far fa-calendar-alt</v-icon>
                          &nbsp; {{momentday(msg.message)}}
                          <br>
                          <v-icon style="font-size: 16px; color: white;">far fa-clock</v-icon> &nbsp; {{msg.message.split('T')[1]}}
                        </div>
                        <div class="templatestyle CSChatThai" v-else-if="msg.typeofmessage === 'template'" :id="msg.tokenmessage">
                            <v-layout style="width: 72vw;padding: 5px; align-items: end;" class="scrolling-wrapper-template">
                                <div class="templateCard" v-for="(card,indexs) in msg.info_ans" :key="msg.tokenmessage+indexs">
                                    <v-layout wrap style="max-width: 350px;min-width: 235px;">
                                        <v-flex xs12 sm12 align-start flexbox style="word-break: break-all; width: 100%; text-align: center;">
                                            <img v-if="card.image" :src="card.image" class="templateImage" :id="msg.tokenmessage" />
                                            <p class="templateTitle">{{card.title}}</p>
                                            <!-- <read-more class="templateDetail" more-str="อ่านเพิ่มเติม" :text="convert(card.detail).replace(/(?:\r\n|\r|\n)/g, '<br>')" link="#" less-str="{{$t('AnswerQuestion.open')}}น้อยลง" :max-chars="100" style="margin-bottom: 0px !important; text-align: left;"></read-more> -->
                                            <p style="text-align: start; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; text-overflow: ellipsis;" class="mb-3" v-html="convert(card.detail, card).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                                            <a v-if="card.detail.length >= 40" @click="clickReadmore(card)" style="text-align: start; display: flex; margin-bottom: 20px;">
                                              <b>{{$t('ChatSide.Read.readmore')}}</b>
                                            </a>
                                            <hr v-if="!card.image" class="hrtemplate" />
                                        </v-flex>
                                        <div v-if="card.image" style="width: 100%; text-align: center;">
                                            <v-flex class="mb-2" xs12 sm12 align-start flexbox v-for="(question, index) in card.choice" :key="index">
                                                <v-btn text class="templateButton" @click="ans_question(question, msg.tokenmessage, msg.tokenuser)">
                                                    <v-icon v-if="question.type=='file'" style="font-size: 12px; margin-right: 5px;">fas fa-download</v-icon>
                                                    <p v-html="convert(question.label, question).replace(/(?:\r\n|\r|\n)/g, '<br>')" class="mb-0"></p>
                                                </v-btn>
                                            </v-flex>
                                        </div>
                                        <div v-else v-for="(choice, i) in card.choice" v-bind:key="'indexchoice'+ i" style="width: 100%;margin-bottom: 6px;">
                                            <li @click="ans_question(choice, msg.tokenmessage, msg.tokenuser)" class="choice_template">{{choice.label}}</li>
                                        </div>
                                    </v-layout>
                                </div>
                            </v-layout>
                        </div>
                        <div class="templatestyle CSChatThai" v-else-if="msg.typeofmessage === 'carousel'" :id="msg.tokenmessage">
                            <v-layout style="width: 72vw;padding: 5px; align-items: end;" class="scrolling-wrapper-template">
                              <div v-for="(info_carousel, index) in msg.elements" :key="index" class="pr-2 pb-2">
                                <v-card style="border-radius: 20px; width: 250px; margin-right: 10px;">
                                  <v-img
                                  @click="btn_answer_carousel(info_carousel)"
                                  :src="info_carousel.image"
                                  :aspect-ratio="16/9"
                                  v-if="info_carousel.image"
                                  style="height: 250px; cursor: pointer;"
                                  >
                                  <v-layout v-if="info_carousel.type !== 'image'" row wrap align-end justify-center style="height: 250px;">
                                    <v-btn v-if="info_carousel.button" rounded color="#0000009c" dark>
                                    <span class="text-transform">{{info_carousel.button}}</span>
                                    </v-btn>
                                  </v-layout>
                                  </v-img>
                                </v-card>
                              </div>
                            </v-layout>
                        </div>
                        <div class="templatestyle CSChatThai" v-else-if="msg.typeofmessage === 'official_template'" :id="msg.tokenmessage">
                          <v-layout style="width: 60vw; padding: 5px; align-items: end;" class="scrolling-wrapper-template">
                            <v-card class="templateCardOff">
                             <h3 class="mb-0" style="color: #2562af;padding-left: 12px;padding-top: 10px;padding-bottom: 10px;">{{msg.element.title}}</h3>
                             <v-img :src="msg.element.image" v-if="msg.element.image" style="height: 120px; cursor: pointer;" @click="btn_img_official_template(msg.element.onclick_img, msg.tokenuser)" contain></v-img>
                             <v-card-title primary-title style="padding-top: 15px !important;">
                               <div>
                                 <read-more class="mb-0" :more-str="$t('ChatSide.Read.readmore')" :text="convert(msg.element.detail, msg.element).replace(/(?:\r\n|\r|\n)/g, '<br>')" link="#" :less-str="$t('ChatSide.Read.readless')" :max-chars="20" style="color:#343433;"></read-more>
                                 <v-divider light v-if="!msg.element.image"></v-divider>
                                 <div v-for="(choice, index) in msg.element.choice">
                                   <v-btn text :style="checkbutton(choice.color,choice.background)" @click="btn_official_template(choice, msg.tokenuser, msg.tokenmessage)" :disabled="(choice.disable == '0')? false: true">
                                     {{choice.label}}
                                   </v-btn>
                                 </div>
                               </div>
                             </v-card-title>
                           </v-card>
                         </v-layout>
                        </div>
                        <div class="contentfile CSChatThai" v-else-if="msg.typeofmessage === 'mention_message'" :id="msg.tokenmessage" @click="msg.tokenuser == tokenuser ? messageMenu(msg, ['mention']) : messageMenu(msg, ['mention'])">
                          <v-row justify="start" align="center">
                            <v-col cols="2">
                              <v-avatar size="40" class="border-avatar">
                                <img v-if="msg.source_message.owner_source_message.path_pic" :src="msg.source_message.owner_source_message.path_pic" class="imgProfilechat pictureRoomChat alligator-turtle" />
                                <img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`" class="imgProfilechat pictureRoomChat alligator-turtle">
                              </v-avatar>
                            </v-col>
                            <v-col :cols="msg.source_message.typeofmessage === 'message' || msg.source_message.typeofmessage === 'mention_message' ? 10 : 7" justify="start" align="start">
                              <p class="mb-0 pl-5">{{msg.source_message.owner_source_message.nickname}}</p>
                              <p class="mb-0 pl-5 pt-2" v-if="msg.source_message.typeofmessage === 'message' || msg.source_message.typeofmessage === 'mention_message'" v-html="convert(msg.source_message.message, msg.source_message).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                              <span class="mb-0 pl-5 pt-2" v-if="msg.source_message.typeofmessage === 'file'">{{$t('ChatSide.file')}}</span>
                              <span class="mb-0 pl-5 pt-2" v-if="msg.source_message.typeofmessage === 'image'">{{$t('ChatSide.image')}}</span>
                              <span class="mb-0 pl-5 pt-2" v-if="msg.source_message.typeofmessage === 'sticker'">{{$t('ChatSide.sticker')}}</span>
                              <span class="mb-0 pl-5 pt-2" v-if="msg.source_message.typeofmessage === 'location'">{{$t('ChatSide.location')}}</span>
                            </v-col>
                            <v-col cols="3" v-if="msg.source_message.typeofmessage !== 'message' && msg.source_message.typeofmessage !== 'mention_message'" justify="center" align="center">
                              <v-icon class="iconFile fz-35" v-if="msg.source_message.typeofmessage === 'file' && extension(msg.source_message.message) === 'fas fa-file-alt'">fas fa-file-pdf</v-icon>
                              <v-icon class="iconFile fz-35" v-else-if="msg.source_message.typeofmessage === 'file'">{{extension(msg.source_message.message)}}</v-icon>
                              <img v-else-if="msg.source_message.typeofmessage === 'image' || msg.source_message.typeofmessage === 'sticker'" :src="msg.source_message.message" class="pictureRoomChat alligator-turtle" width="35px" height="35px"  />
                              <v-icon class="iconFile fz-25" v-else-if="msg.source_message.typeofmessage === 'location'">fa-solid fa-location-dot</v-icon>
                            </v-col>
                          </v-row>
                          <v-divider class="mt-2 color-divider"></v-divider>
                          <v-row justify="start" class="mt-2 pl-3">
                            <p v-html="convert(msg.message, msg).replace(/(?:\r\n|\r|\n)/g, '<br>')"
                                style="display: block;
                                max-width: 55vw;
                                min-width: 55vw;
                                text-align: left;">
                            </p>
                          </v-row>
                        </div>
                        <!-- task message -->
                        <div class="contentNote cursor pa-2" v-else-if="msg.typeofmessage === 'task_message'"
                          @click="openDialog(msg, 'task')">
                          <v-row justify="start" align="center" class="pl-3 pt-2 pb-1">
                            <v-col v-if="msg.state.name !== undefined" cols="3" class="pr-0 pl-0 pt-0">
                              <v-chip dark small label :color="checkPriorityTask(msg.task_info.priority)">
                                {{ msg.state.name }}
                              </v-chip>
                            </v-col>
                            <v-col cols="9" class="pl-0 pt-0">
                              <h3 class="mb-0 titletask">{{ msg.project_name }}</h3>
                              <p class="mb-0 detailtask">{{ msg.title }}</p>
                            </v-col>
                          </v-row>
                          <v-divider v-if="msg.task_info.assign.length !== 0" class="icontask"></v-divider>
                          <v-row v-if="msg.task_info.assign.length !== 0"
                            class="mt-1 justify-center align-center pa-4">
                            <v-col class="pa-0 mb-1" cols="12" v-for="(item, index) in msg.task_info.assign"
                              :key="index">
                              <v-chip label>
                                <v-avatar size="20">
                                  <img v-if="item.path_pic" :src="item.path_pic" alt="alt"
                                    class="imgProfilechat pictureRoomChat alligator-turtle">
                                  <img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`"
                                    class="imgProfilechat pictureRoomChat alligator-turtle">
                                </v-avatar>
                                <p class="mb-0 pl-1 text-overflow">{{ item.nickname }}</p>
                              </v-chip>
                            </v-col>
                          </v-row>
                          <v-divider class="mt-2 color-divider"></v-divider>
                          <v-row justify="start" class="mt-2 pl-3 pr-2 pb-1">
                            <span v-if="msg.message === 'assign_task'">{{ $t('ChatSide.Task.editAssign') }}</span>
                            <span v-else-if="msg.message === 'create_task'">{{ $t('ChatSide.Task.viewDetail')
                              }}</span>
                            <span v-else>{{ $t('ChatSide.Task.viewDetail') }}</span>
                            <v-spacer></v-spacer>
                            <v-icon class="icontask">mdi-chevron-right</v-icon>
                          </v-row>
                        </div>

                        <v-card class="contentNote CSChatThai pa-3" v-else-if="msg.typeofmessage === 'note'" :id="msg.tokenmessage">
                          <v-layout @click="openDialog(msg, 'note')">
                            <v-flex xs12 sm12 md12 lg12 xl12>
                              <p v-html="convert(msg.message, msg).replace(/(?:\r\n|\r|\n)/g, '<br>')" class="mb-1"></p>
                              <p v-if="msg.message.length == 20" class="mb-0"> ...</p>
                            </v-flex>
                          </v-layout>
                          <v-divider light></v-divider>
                          <v-card-actions class="pl-0 pr-0" @click="openDialog(msg, 'note')">
                            <span>{{$t('ChatSide.note')}} </span>
                            <v-spacer></v-spacer>
                            <v-icon class="contentNote" style="font-size: 16px; padding-right: 10px; text-align: end !important;">fa-solid fa-angle-right</v-icon>
                          </v-card-actions>
                        </v-card>
                        <div class="content contentnot_support CSChatThai" v-else :id="msg.tokenmessage">
                            <span>{{$t('ChatSide.notSupportVersion')}}</span>
                        </div>
                        <div style="align-items: end; justify-content: end; display: inline-grid;" v-if="msg.tokenuser !== tokenuser && msg.typeofmessage !== 'unsend_message' && msg.typeofmessage !== 'system' && msg.typeofmessage !== 'system_action' && msg.typeofmessage !== 'system_action_albums' && msg.typeofmessage !== 'system_action_task'">
                          <v-icon @click="msg.tokenuser == tokenuser ? messageMenu(msg, ['download', 'cancel', 'mention', 'forward', 'onebox']) : messageMenu(msg, ['download', 'mention', 'forward', 'onebox'])" class="fz-18 mb-2" v-if="msg.typeofmessage == 'file' && extension(msg.message) == 'audio' && !statusForward">fa-solid fa-arrow-up-from-bracket</v-icon>
                          <span class="pl-2" style="font-size: 10px; color: #424242b3;">{{timeMoment(msg.timestamp)}}</span>
                        </div>
                    </div>

                    <!-- date picker quickreply -->
                    <v-date-picker v-model="dateselect" v-if="datepicker" :max="maxdate" :min="mindate" :landscape="landscape">
                      <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="datepicker = false">{{$t('AnswerQuestion.cancel')}}</v-btn>
                        <v-btn text color="primary" @click="senddate()">{{$t('AnswerQuestion.ok')}}</v-btn>
                    </v-date-picker>

                    <v-time-picker v-model="timeselect" :max="maxtime" :min="mintime" v-if="timepicker" format="24hr" :landscape="landscape">
                         <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="timepicker = false">{{$t('AnswerQuestion.cancel')}}</v-btn>
                          <v-btn text color="primary" @click="sendtime()">{{$t('AnswerQuestion.ok')}}</v-btn>
                    </v-time-picker>
                </div>

                <div v-if="gotoBtm || gotoReply" :class="gotoBtm || gotoReply ? 'typer-backmsg-inactive' : 'typer-backmsg'"
                    ref="btnBackMsg">
                    <v-row class="justify-center align-center">
                      <v-col cols="3"></v-col>
                      <v-col cols="6" class="justify-center align-center">
                        <v-row class="justify-center align-center" v-if="gotoReply">
                          <v-btn class="btn-confirm text-transform" small dark @click="goBackMsg(idReplyMsg)">
                            <v-icon dark class="fz-18 pr-2">fa-solid fa-arrow-rotate-left</v-icon>
                            <span class="text-transform">{{ $t('ChatSide.goBackMsg') }}</span>
                          </v-btn>
                        </v-row>
                        <v-row class="justify-center align-center" v-if="gotoMsg">
                          <v-chip
                            pill
                            close
                            @click:close="gotoMsg = false, socketmessage = null"
                            @click.native="gotoBtmMsg()"
                          >
                            <v-avatar left>
                              <v-img v-if="new_message.path_pic" :src="new_message.path_pic"></v-img>
                              <img v-else-if="new_message.type === 'bot'" :src="`${publicPath}/assets/img/default_profile/bot-white.png`" :lazy-src="`${publicPath}/assets/img/default_profile/bot-white.png`" lazy="loading" alt="" class="img-position">
                              <img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`" :lazy-src="`${publicPath}/assets/img/default_profile/bot-white.png`" lazy="loading" alt="" class="img-position">
                            </v-avatar>
                            <p class="mb-0 text-overflow-new-msg" v-if="new_message.typeofmessage === 'message'" v-html="convertMsg(new_message.message)"></p>
                            <span v-else-if="new_message.typeofmessage === 'image'">{{ $t('ChatSide.image') }}</span>
                            <span v-else-if="new_message.typeofmessage === 'file'">{{ $t('ChatSide.file') }}</span>
                            <span v-else-if="new_message.typeofmessage === 'sticker'">{{ $t('ChatSide.sticker') }}</span>
                            <span v-else-if="new_message.typeofmessage === 'video'">{{ $t('ChatSide.video') }}</span>
                            <span v-else-if="new_message.typeofmessage === 'location'">{{ $t('ChatSide.location') }}</span>
                            <span v-else-if="new_message.typeofmessage === 'contact'">{{ $t('ChatSide.contact') }}</span>
                            <p v-else-if="new_message.typeofmessage === 'albums_message'" class="mb-0">
                              <span v-if="new_message.message === 'addimage_albums'">{{ $t('Dialog.album.headerAddImage') }}</span>
                              <span v-else>{{ $t('Dialog.album.headerCreate') }}</span>
                            </p>
                            <span v-else>{{ $t('ChatSide.newMessage') }}</span>
                          </v-chip>
                        </v-row>
                      </v-col>
                      <v-col cols="3">
                        <v-row class="justify-end align-center mr-2" v-if="gotoBtm">
                          <v-btn dark small color="#2463af" fab @click="gotoBtmMsg()">
                            <v-icon dark class="fz-18">mdi-arrow-down</v-icon>
                          </v-btn>
                        </v-row>
                      </v-col>
                    </v-row>
                  </div>

                <!-- quickreply -->
                <div class="scrolling-quickreply" v-if="list_quickreply.quick_reply">
                    <a v-for="(item,index) in list_quickreply.quick_reply" :key="index">
                        <v-btn v-if="item.type == 'link' || item.type == 'webview'" small class="btn-quickreply" @click="ans_quickreply(item)">
                            <v-icon v-if="item.type == 'link' || item.type == 'webview'" style="font-size: 12px;" class="text-overflow-quickreply">fas fa-link</v-icon> &nbsp;&nbsp; <span class="text-overflow-quickreply">{{item.label}}</span>
                        </v-btn>
                        <v-btn v-else-if="item.type == 'location'" small class="btn-quickreply" @click="ans_quickreply(item)">
                            <v-icon style="font-size: 12px;" class="text-overflow-quickreply">fa-solid fa-location-dot</v-icon> &nbsp;&nbsp; <span class="text-overflow-quickreply">{{item.label}}</span>
                        </v-btn>
                        <v-btn v-else-if="item.type == 'text'" small class="btn-quickreply" @click="ans_quickreply(item)">
                            <span class="text-overflow-quickreply">{{item.label}}</span>
                        </v-btn>
                        <v-btn v-else-if="item.type == 'datepicker' || item.type == 'datetimepicker'" small class="btn-quickreply" @click="setpicker(item)">
                            <v-icon style="font-size: 12px;" class="text-overflow-quickreply">fas fa-calendar-alt</v-icon> &nbsp;&nbsp; <span class="text-overflow-quickreply">{{item.label}}</span>
                        </v-btn>
                        <v-btn v-else-if="item.type == 'link_market'" small class="btn-quickreply" @click="ans_quickreply(item)">
                            <v-icon style="font-size: 12px;" class="text-overflow-quickreply">fa-solid fa-store</v-icon> &nbsp;&nbsp; <span class="text-overflow-quickreply">{{item.label}}</span>
                        </v-btn>
                        <v-btn v-else-if="item.type == 'ocr'" small class="btn-quickreply" @click="ans_quickreply(item)">
                          <span class="text-overflow-quickreply">{{item.label}}</span>
                        </v-btn>
                        <v-btn v-else-if="item.type == 'ekyc'" small class="btn-quickreply" @click="ans_quickreply(item)">
                          <v-icon style="font-size: 12px;" class="text-overflow-quickreply">fas fa-id-card</v-icon>
                            &nbsp;&nbsp; <span class="text-overflow-quickreply">{{item.label}}</span>
                        </v-btn>
                        <v-btn v-else-if="item.type == 'file'" small class="btn-quickreply" @click="ans_quickreply_file(item)">
                          <v-icon style="font-size: 12px;" class="text-overflow-quickreply">fa-solid fa-paperclip</v-icon>
                            &nbsp;&nbsp; <span class="text-overflow-quickreply">{{item.label}}</span>
                        </v-btn>
                        <v-btn v-else-if="item.type == 'image'" small class="btn-quickreply" @click="ans_quickreply_file(item)">
                          <v-icon style="font-size: 12px;" class="text-overflow-quickreply">fa-solid fa-image</v-icon>
                            &nbsp;&nbsp; <span class="text-overflow-quickreply">{{item.label}}</span>
                        </v-btn>
                    </a>
                </div>

                <!-- preview sticker -->
                <div class="previewMessage" v-if="previewMessage">
                  <v-row class="justify-center align-start">
                    <v-col cols="2"></v-col>
                    <v-col cols="8" justify="center" align="center">
                      <img style="width: 100px; height: 100px;" :src="previewMessageInfor.s3_name" @click="sendSticker(previewMessageInfor)">
                    </v-col>
                    <v-col cols="2">
                      <v-icon color="white" @click="previewMessage = false">mdi-close</v-icon>
                    </v-col>
                  </v-row>
                </div>

                <!-- reply mesaage -->
                <div :class="focusKey ? 'previewMessage-Active': 'previewMessage'" v-if="reply_status">
                  <v-row justify="center" align="center">
                    <v-col cols="2">
                      <v-avatar size="40" class="border-avatar">
                        <img v-if="reply_data.path_pic" :src="reply_data.path_pic" class="imgProfilechat pictureRoomChat alligator-turtle" />
                        <img v-else-if="reply_data.type === 'bot'" :src="`${publicPath}/assets/img/default_profile/bot-white.png`" class="imgProfilechat pictureRoomChat alligator-turtle">
                        <img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`" class="imgProfilechat pictureRoomChat alligator-turtle">
                      </v-avatar>
                    </v-col>
                    <v-col cols="10" justify="start" align="start" class="pl-0">
                      <v-row>
                        <v-col cols="10" justify="start" align="start" class="pb-0">
                          <p class="text-overflow mb-0 color-white"><b>{{reply_data.nickname}}</b></p>
                        </v-col>
                        <v-col cols="2" justify="start" align="start" class="pb-0">
                          <v-icon color="white" @click="reply_status = false">mdi-close</v-icon>
                        </v-col>
                      </v-row>
                      <v-row v-if="reply_data.typeofmessage === 'message' || reply_data.typeofmessage === 'mention_message'">
                        <v-col cols="12" justify="start" align="start" class="pt-0">
                          <p class="text-overflow mb-0 color-white" v-html="convertMsg(reply_data.message)"></p>
                        </v-col>
                      </v-row>
                      <v-row v-else>
                        <v-col cols="3" justify="start" align="start" class="pt-0">
                          <span class="color-white" v-if="reply_data.typeofmessage === 'image'">{{$t('ChatSide.image')}}</span>
                          <span class="color-white" v-if="reply_data.typeofmessage === 'file'">{{$t('ChatSide.file')}}</span>
                          <span class="color-white" v-if="reply_data.typeofmessage === 'sticker'">{{$t('ChatSide.sticker')}}</span>
                          <span class="color-white" v-if="reply_data.typeofmessage === 'location'">{{$t('ChatSide.location')}}</span>
                        </v-col>
                        <v-col cols="9" justify="start" align="end" class="pt-0 pr-5">
                          <v-icon class="color-white fz-35" v-if="reply_data.typeofmessage === 'file' && extension(reply_data.message) === 'fas fa-file-alt'">fas fa-file-pdf</v-icon>
                          <v-icon class="color-white fz-35" v-else-if="reply_data.typeofmessage === 'file' && extension(reply_data.message) !== 'audio'">{{extension(reply_data.message)}}</v-icon>
                          <v-icon class="color-white fz-35" v-else-if="reply_data.typeofmessage === 'file' && extension(reply_data.message) === 'audio'">fa-solid fa-file-audio</v-icon>
                          <img v-else-if="reply_data.typeofmessage === 'image'" :src="reply_data.message" class="imgProfilechat pictureRoomChat alligator-turtle" />
                          <img v-else-if="reply_data.typeofmessage === 'sticker'" :src="reply_data.file_name" class="imgProfilechat pictureRoomChat alligator-turtle" />
                          <v-icon class="color-white fz-25" v-else-if="reply_data.typeofmessage === 'location'">fa-solid fa-location-dot</v-icon>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </div>

                <!-- richmenu -->
                <v-row ref="sheetrichmenu" justify="center" v-if="sheetrichmenu && (width_layout <= 500)" :class="parseInt(ListMenuData.type_menu) <= 7 ? 'mt-9' : 'mt-5'" :style="parseInt(ListMenuData.type_menu) <= 7 ? 'width: 90vw !important; margin: 20px;' : 'width: 100vw !important; margin: 0px;'">
                  <Richmenu :type_richmenu="parseInt(ListMenuData.type_menu)" :Richmenudialog="Richmenudialog" :inforrichmenu="ListMenuData.list_menu" @emitrichmenu="emitrichmenu"></Richmenu>
                </v-row>
                <v-row ref="sheetrichmenu" style="height: 130px; min-height: 180px; max-height: 180px;" class="justify-space-around align-end" v-if="sheetrichmenu && (width_layout > 500)" :class="parseInt(ListMenuData.type_menu) <= 7 ? 'mt-9' : 'mt-5'" :style="parseInt(ListMenuData.type_menu) <= 7 ? '' : ''">
                  <v-col :cols="width_layout < 950 ? 4 : 4"></v-col>
                  <v-col :cols="width_layout < 950 ? 4 : 2" align="center">
                    <Richmenu :type_richmenu="parseInt(ListMenuData.type_menu)" :Richmenudialog="Richmenudialog" :inforrichmenu="ListMenuData.list_menu" @emitrichmenu="emitrichmenu"></Richmenu>
                  </v-col>
                  <v-col :cols="width_layout < 950 ? 4 : 4"></v-col>
                </v-row>

                <div class="typer-richmenu" v-if="RichmenuState">
                  <v-row justify="center" align="center" class="pl-2 pr-2">
                    <v-col cols="2" justify="center" align="center" @click="stateRichmenu(false)">
                      <v-icon class="typingbox-button">fa-solid fa-keyboard</v-icon>
                    </v-col>
                    <v-col cols="10" justify="center" align="center" class="pl-0">
                      <v-btn v-if="!sheetrichmenu" class="typingbox-button text-transform" block outlined @click="showRichMenu(true)">
                        {{ListMenuData.menu_label}}
                        <v-icon class="typingbox-button pl-2 fz-16">fa-solid fa-caret-up</v-icon>
                      </v-btn>
                      <v-btn v-else class="typingbox-button text-transform" block outlined @click="showRichMenu(false)">
                        {{ListMenuData.menu_label}}
                        <v-icon class="typingbox-button pl-2 fz-16">fa-solid fa-caret-down</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>
                <div v-else>
                  <div class="typer-menu-forward" v-if="statusForward">
                    <v-row>
                      <v-col cols="6" class="pt-0 pb-0" @click="cancelForward()">
                        <v-btn class="btnCancel" outlined block large>{{$t('AnswerQuestion.cancel')}}</v-btn>
                      </v-col>
                      <v-col cols="6" class="pt-0 pb-0" @click="openDialog('', 'listfriend')">
                        <v-btn class="btnConfirm" block large v-if="selectedForward.length === 0" :disabled="selectedForward.length === 0">{{$t('AnswerQuestion.forward')}}</v-btn>
                        <v-btn class="btnConfirm" block large v-else>{{$t('AnswerQuestion.forward')}} ({{selectedForward.length}})</v-btn>
                      </v-col>
                    </v-row>
                  </div>
                  <!-- btn to bottom -->
                  <!-- <div v-if="gotoBtm || gotoReply" :class="gotoBtm || gotoReply ? 'typer-backmsg-inactive' : 'typer-backmsg'"
                    ref="btnBackMsg">
                    <v-row class="justify-center align-center">
                      <v-col cols="3"></v-col>
                      <v-col cols="6" class="justify-center align-center">
                        <v-row class="justify-center align-center" v-if="gotoReply">
                          <v-btn class="btn-confirm text-transform" small dark @click="goBackMsg(idReplyMsg)">
                            <v-icon dark class="fz-18 pr-2">fa-solid fa-arrow-rotate-left</v-icon>
                            <span class="text-transform">{{ $t('ChatSide.goBackMsg') }}</span>
                          </v-btn>
                        </v-row>
                        <v-row class="justify-center align-center" v-if="gotoMsg">
                          <v-chip
                            pill
                            close
                            @click:close="gotoMsg = false, socketmessage = null"
                            @click.native="gotoBtmMsg()"
                          >
                            <v-avatar left>
                              <v-img v-if="new_message.path_pic" :src="new_message.path_pic"></v-img>
                              <img v-else-if="new_message.type === 'bot'" :src="`${publicPath}/assets/img/default_profile/bot-white.png`" :lazy-src="`${publicPath}/assets/img/default_profile/bot-white.png`" lazy="loading" alt="" class="img-position">
                              <img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`" :lazy-src="`${publicPath}/assets/img/default_profile/bot-white.png`" lazy="loading" alt="" class="img-position">
                            </v-avatar>
                            <p class="mb-0 text-overflow-new-msg" v-if="new_message.typeofmessage === 'message'" v-html="convertMsg(new_message.message)"></p>
                            <span v-else-if="new_message.typeofmessage === 'image'">{{ $t('ChatSide.image') }}</span>
                            <span v-else-if="new_message.typeofmessage === 'file'">{{ $t('ChatSide.file') }}</span>
                            <span v-else-if="new_message.typeofmessage === 'sticker'">{{ $t('ChatSide.sticker') }}</span>
                            <span v-else-if="new_message.typeofmessage === 'video'">{{ $t('ChatSide.video') }}</span>
                            <span v-else-if="new_message.typeofmessage === 'location'">{{ $t('ChatSide.location') }}</span>
                            <span v-else-if="new_message.typeofmessage === 'contact'">{{ $t('ChatSide.contact') }}</span>
                            <p v-else-if="new_message.typeofmessage === 'albums_message'" class="mb-0">
                              <span v-if="new_message.message === 'addimage_albums'">{{ $t('Dialog.album.headerAddImage') }}</span>
                              <span v-else>{{ $t('Dialog.album.headerCreate') }}</span>
                            </p>
                            <span v-else>{{ $t('ChatSide.newMessage') }}</span>
                          </v-chip>
                        </v-row>
                      </v-col>
                      <v-col cols="3">
                        <v-row class="justify-end align-center mr-2" v-if="gotoBtm">
                          <v-btn dark small color="#2463af" fab @click="gotoBtmMsg()">
                            <v-icon dark class="fz-18">mdi-arrow-down</v-icon>
                          </v-btn>
                        </v-row>
                      </v-col>
                    </v-row>
                  </div> -->

                  <div ref="typerMenu" class="typer" v-if="statemember === 'active' && !statusForward">
                    <v-icon class="typingbox-button" v-if="ListMenuData !== ''" @click="stateRichmenu(true)">fa-solid fa-bars</v-icon>
                    <v-btn dark icon class="emoji-panel">
                        <v-icon class="typingbox-button" @click="showMenuChat(true)" v-if="!menuChat">fa-solid fa-circle-plus</v-icon>
                        <v-icon class="typingbox-button" @click="showMenuChat(false)" v-else>fa-solid fa-circle-xmark</v-icon>
                    </v-btn>

                    <!-- <v-text-field
                      @focus="InputFocus($event)"
                      solo
                      :placeholder="$t('ChatSide.textarea.normal')"
                      :append-icon="marker ? 'fa-solid fa-face-grin' : 'fa-solid fa-face-grin'"
                      hide-details
                      rows="1"
                      @keyup.enter="sendMessage(msgSend)"
                      @click:append="chsheetsticker($event)"
                      v-model="msgSend"
                      style="height:auto !important;"
                      >
                  </v-text-field> -->

                  <!-- chat box -->
                  <a-mentions 
                    id="textsendmsg"
                    ref="textareaChat"
                    :placeholder="$t('ChatSide.textarea.normal')"
                    v-model="msgSend"
                    :rows="rows"
                    :loading="loading"
                    placement="top"
                    @focus="InputFocus($event)"
                    @select="onSelect"
                    @search="onSearch"
                    @keyup.enter="list_mention.length !== 0 ? sendMessage(convertMsgMention(msgSend, list_mention)): sendMessage(msgSend)"
                  >
                  <!-- @keypress="list_mention.length !== 0 ? sendMessage(convertMsgMention(msgSend, list_mention)): sendMessage(msgSend)" -->
                    <a-mentions-option
                            v-for="({ tokenuser, name,  profilepicture: avatar }) in listfriend_filter"
                            :key="tokenuser"
                            :value="`${name}-${tokenuser}`"
                          >
                      <v-avatar size="40" class="mr-5">
                        <img v-if="avatar" :src="avatar" :alt="avatar" class="img-position mr-5" :id="`imgprofilechat-${tokenuser}`"
                          v-on:error="setDefaultImageChat(tokenuser)">
                        <img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`" alt="" class="img-position mr-5">
                      </v-avatar>
                      <span class="ml-5 pl-5 icon-color-active" :id="tokenuser">{{space_key}}{{
                        name }}</span>
                    </a-mentions-option>
                  </a-mentions>

                    <v-btn icon @click="chsheetsticker($event)" :disabled="statemember !== 'active'">
                      <v-icon color="white">fa-solid fa-face-grin</v-icon>
                    </v-btn>
                    <v-btn dark icon class="emoji-panel" v-if="msgSend">
                        <v-icon :disabled="!msgSend" class="typingbox-button-send" @click="list_mention.length !== 0 ? sendMessage(convertMsgMention(msgSend, list_mention)): sendMessage(msgSend)">mdi-send</v-icon>
                    </v-btn>
                  </div>
                  <div class="typer" v-if="statemember !== 'active' && !statusForward">
                      <v-btn disabled dark icon class="emoji-panel">
                          <v-icon class="typingbox-button">far fa-file-image</v-icon>
                      </v-btn>
                      <v-btn disabled dark icon class="emoji-panel">
                          <v-icon class="typingbox-button">fa-solid fa-paperclip</v-icon>
                      </v-btn>
                      <v-text-field disabled solo :placeholder="$t('ChatSide.textarea.inactive')" hide-details rows="1" style="height:auto !important;"></v-text-field>
                      <v-btn disabled dark icon class="emoji-panel">
                          <v-icon disabled class="typingbox-button-send">mdi-send</v-icon>
                      </v-btn>
                  </div>
                </div>

                <!--  new menu sticker -->
                <v-bottom-sheet
                  v-model="menuSticker"
                  persistent
                  :style="stylechat"
                >
                  <v-card
                    class="text-center"
                    :height="`${heightChat * 0.5}`"
                  >
                    <v-card class="pt-1">
                      <v-row class="justify-center align-start" v-touch="{
                        down: () => menuSticker = !menuSticker,
                      }">
                        <v-icon color="grey" class="fz-55">fa-solid fa-minus</v-icon>
                      </v-row>
                      <v-row class="justify-start align-center">
                        <v-col cols="2" justify="center" align="center" class="pr-0">
                          <v-icon v-if="selectSticker" color="#2463af">fa-solid fa-face-grin-wide</v-icon>
                          <!-- <v-icon v-else @click="showSticker(true)" color="#2463af">fa-solid fa-face-grin-hearts</v-icon> -->
                        </v-col>
                        <v-col cols="10" class="pl-0">
                          <v-tabs
                            v-model="tab"
                            background-color="white"
                            centered
                            show-arrows
                            v-if="selectSticker"
                          >
                            <v-tabs-slider></v-tabs-slider>
                            <v-tab
                              v-for="(item, index) in sticker"
                              :key="index"
                              :href="'#tab-' + item.token_sticker"
                            >
                              <img style="width: 30px;" :src="item.path_title">
                            </v-tab>
                          </v-tabs>

                          <v-tabs
                            v-model="tabemo"
                            background-color="white"
                            centered
                            show-arrows
                            v-else
                          >
                            <v-tabs-slider></v-tabs-slider>
                            <v-tab
                              v-for="(emojiGroup, category) in emojiGroups"
                              :key="category"
                              :href="'#tab-' + category"
                            >
                            {{emojiGroup['smile']}}
                            {{emojiGroup['bear']}}
                            {{emojiGroup['soccer']}}
                            {{emojiGroup['house_with_garden']}}
                            {{emojiGroup['symbols']}}
                            </v-tab>
                          </v-tabs>
                        </v-col>
                      </v-row>

                      <v-tabs-items v-model="tab" v-if="selectSticker">
                        <v-tab-item
                          v-for="(item, i) in sticker"
                          :key="i"
                          :value="'tab-' + item.token_sticker"
                        >
                          <v-card style="height: 38vh; overflow-y: scroll;">
                            <v-card-text>
                              <v-layout wrap style="flex-wrap: wrap;">
                                <v-flex sm4 md4 xs4 style=" justify-content: center;" v-for="(items, index) in item.list_sticker" :key="index">
                                  <v-layout style=" justify-content: center;display: flex;text-align: center;">
                                    <img style="width: 80px; height: 80px;" :src="items.s3_name" @click="sendSticker(items.message)">
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                      </v-tabs-items>

                      <v-tabs-items v-model="tabemo" v-else>
                        <v-tab-item
                          v-for="(emojiGroup, category) in emojiGroups"
                          :key="category"
                          :value="'tab-' + category"
                        >
                          <v-card style="height: 40vh; overflow-y: scroll;">
                            <v-card-text>
                              <v-layout wrap style="flex-wrap: wrap;">
                                <div class="emojis">
                                  <span v-for="(emoji, emojiName) in emojiGroup" :key="emojiName" @click="append(emoji)" :title="emojiName">{{ emoji }}</span>
                                </div>
                              </v-layout>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                      </v-tabs-items>
                    </v-card>
                  </v-card>
                </v-bottom-sheet>

                <!-- new menu chat -->
                <v-bottom-sheet
                  v-model="menuChatBottom"
                  persistent
                  :style="stylechat"
                >
                  <v-sheet
                    class="text-center"
                    :height="`${heightChat * 0.3}`"
                  >
                  <v-row class="justify-center align-start" v-touch="{
                    down: () => menuChatBottom = !menuChatBottom,
                  }">
                    <v-icon color="grey" class="fz-55">fa-solid fa-minus</v-icon>
                  </v-row>
                  <v-layout row wrap justify-start align-center class="pl-2 pr-2">
                    <v-flex xs4 md4 sm4>
                      <v-layout @click="openInput('#uploadpic')" align-center justify-center wrap column>
                        <v-btn icon class="emoji-panel">
                          <v-icon color="#2463af" class="fz-30">far fa-file-image</v-icon>
                        </v-btn>
                        <p class="mb-0" style="font-size: 15px; color: #2463af; padding-top: 10px;">{{$t('ChatSide.image')}}</p>
                      </v-layout>
                    </v-flex>
                    <v-flex xs4 md4 sm4>
                      <v-layout @click="openInput('#uploadfileChat')" align-center justify-center column wrap>
                        <v-btn dark icon class="emoji-panel">
                          <v-icon color="#2463af" class="fz-30">fa-solid fa-paperclip</v-icon>
                        </v-btn>
                        <p class="mb-0" style="font-size: 15px; color: #2463af; padding-top: 10px;">{{$t('ChatSide.file')}}</p>
                      </v-layout>
                    </v-flex>
                    <v-flex xs4 md4 sm4>
                      <v-layout align-center justify-center column wrap>
                        <v-btn dark icon class="emoji-panel">
                            <v-icon color="#2463af" class="fz-30" @click="openDialog('','contact')">fa-solid fa-user</v-icon>
                        </v-btn>
                        <p class="mb-0" style="font-size: 15px; color: #2463af; padding-top: 10px;">{{$t('ChatSide.friend')}}</p>
                      </v-layout>
                    </v-flex>
                    <v-flex xs4 md4 sm4 class="mt-2">
                      <v-layout align-center justify-center column wrap>
                        <v-btn dark icon class="emoji-panel">
                            <v-icon color="#2463af" class="fz-30" @click="openDialog('','location')">fa-solid fa-location-dot</v-icon>
                        </v-btn>
                        <p class="mb-0" style="font-size: 15px; color: #2463af; padding-top: 10px;">{{$t('ChatSide.location')}}</p>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-sheet>
                </v-bottom-sheet>
            </div>
        </div>
        <div style="display:none;">
            <input multiple type="file" id="uploadpic" @change="sendFileAndImage($event)" accept="image/*" />
            <input multiple type="file" id="uploadfileChat" @change="sendFileAndImage($event)" />
            <input type="file" id="uploadpic_ocr" @change="onimgSelected_ocr($event)" @click="clearImage()" accept="image/*" />
            <input type="file" id="uploadpic_quickreply" @change="onimgSelected_quickreply($event)" @click="clearImage()" accept="image/*" />
            <input type="file" id="uploadfile_quickreply" @change="onimgSelected_quickreply($event)" @click="clearImage()" />
        </div>
        <ReadmoreDialog :dialogReadmore="dialogReadmore" :detailReadmore="detailReadmore" @closeReadmoreDialog="closeReadmoreDialog" />
        <WebviewBigDialog :tokenuser="tokenuser" :tokenroom="tokenroom" :dialogWebviewbig="dialogWebviewbig" :Webview_item="Webview_item" @closeWebview="closeWebview"></WebviewBigDialog>
        <WebviewBigOcrDialog :tokenuser="tokenuser" :tokenroom="tokenroom" :dialogWebviewbig_ocr="dialogWebviewbig_ocr" :Webview_item="Webview_item_ocr" @closeWebview="closeWebview"></WebviewBigOcrDialog>
        <CheckBrowserDialog :checkBrowserDialog="checkBrowserDialog" @closeCheckBrowser="closeCheckBrowser" :checkBrowserInfor="checkBrowserInfor"></CheckBrowserDialog>
        <EditNoteChatDialog :NoteDetail="NoteDetail" :EditNoteChatDialog="EditNoteChatDialog" @emitComponents="emitComponents" @closeComponents="closeComponents"/>
        <DetailNoteChatDialog :NoteDetail="NoteDetail" :DetailNoteChatDialog="DetailNoteChatDialog" @emitComponents="emitComponents" @closeComponents="closeComponents"/>
        <NoteChat :NoteChatDialog="NoteChatDialog" :NoteChatDetail="NoteChatDetail" @closeComponents="closeComponents"/>
        <DetailFriendDialog :DetailFriendDialog="DetailFriendDialog" :InforFriend="InforFriend" @closeDialog="closeDialog" />
        <ListBottomMenu :ListBottomMenu="ListBottomMenu" :ListBottomItem="ListBottomItem" @emitListBottom="emitListBottom" @closeAlertDialog="closeAlertDialog"/>
        <ErrorDialog :ErrorDialog="ErrorDialog" :ErrorDialogDetail="ErrorDialogDetail" @closeAlertDialog="closeAlertDialog"/>
        <WarningDialog :WarningDialog="WarningDialog" :WarningDialogDetail="WarningDialogDetail" @emitWarning="emitWarning" @closeAlertDialog="closeAlertDialog"/>
        <QrCodeRichMenuDialog :dialogQrcodRichMenu="dialogQrcodRichMenu" :tokenroom="tokenroom" @closedialogQrcode="closedialogQrcode" :QrcodeInfor="QrcodeInfor"></QrCodeRichMenuDialog>
        <ListContact :ListContactDialog="ListContactDialog" :ListContactDetail="ListContactDetail" @closeComponents="closeComponents"/>
        <SendLocation :LocationDialog="LocationDialog" :LocationDetail="LocationDetail" @closeComponents="closeComponents"/>
        <ListForward :ListForwardDialog="ListForwardDialog" :ListForwardDetail="ListForwardDetail" @emitComponents="emitComponents" @closeComponents="closeComponents"/>
        <SendFileOnebox :SendFileOneboxDialog="SendFileOneboxDialog" :SendFileOneboxDetail="SendFileOneboxDetail" @closeComponents="closeComponents" />
        <DetailAlbums :DetailAlbumsDialog="DetailAlbumsDialog" :DetailAlbumsChatDialog="DetailAlbumsChatDialog" :AlbumsRoom="tokenroom" :tokenuser="tokenuser" @closeComponents="closeComponents"></DetailAlbums>
        <ListAlbumChat :ListAlbumsDialog="ListAlbumsDialog" :ListAlbumsDetail="ListAlbumsDetail" :ListAlbumsImage="ListAlbumsImage" :AlbumsRoom="tokenroom" :tokenuser="tokenuser" @closeComponents="closeComponents"></ListAlbumChat>
        <SendMail :dialogCreatemail="sendMailDialog" :message="sendMailDetail" :datauser="data_user" @closeComponents="closeComponents"></SendMail>
        <DetailTask :dialogDetailTask="dialogDetailTask" :taskid="taskid" :roomid="tokenroom" @closeDetailTask="closeDetailTask"></DetailTask>
      <!-- </div> -->
  </vue100vh>
</template>
<script>
import ErrorDialog from '@/components/Alert/Error'
import WarningDialog from '@/components/Alert/Warning'
import VuePdfApp from "vue-pdf-app";
// import this to use default icons for buttons
import "vue-pdf-app/dist/icons/main.css";
import pdf from 'vue-pdf'
import vue100vh from 'vue-100vh'
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
import {
  VueScreenSizeMixin
} from 'vue-screen-size'
import { vplayer, aplayer } from 'vue-hls-player'
import QrCodeRichMenuDialog from '@/components/dialog/QrCodeRichMenuDialog'
import ReadmoreDialog from '@/components/dialog/ReadmoreDialog'
import WebviewBigDialog from '@/components/dialog/WebviewBigDialog'
import WebviewBigOcrDialog from '@/components/dialog/WebviewOcrDialog'
import CheckBrowserDialog from '@/components/dialog/CheckBrowserDialog'
import EditNoteChatDialog from '@/components/EditNoteChat'
import DetailNoteChatDialog from '@/components/DetailNoteChat'
import NoteChat from '@/components/NoteChat'
import DetailFriendDialog from '@/components/DetailFriend'
import LinkPrevue from 'link-prevue'
import ListBottomMenu from '@/components/Alert/ListBottomMenu'
import Richmenu from '@/components/Richmenu'
import ListContact from '@/components/ListContact'
import ListForward from '@/components/ListForward'
import SendLocation from '@/components/Location'
import SendFileOnebox from '@/components/SendFileOnebox'
import DetailAlbums from "@/components/DetailAlbumsChat.vue"
import ListAlbumChat from "@/components/ListAlbumsChat.vue"
import SendMail from '@/components/SendMail.vue';
import DetailTask from '@/views/Web/Manage/task/detail_task_dialog_mo.vue'
import {
  sync
} from 'vuex-pathify'
import {
  Momenttime,
  Encode,
  Decode
} from '@/services'
var _ = require('lodash')
const emojiGroups = require('../../public/assets/json/emoji')

export default {
  mixins: [VueScreenSizeMixin],
  data() {
    return {
      taskid: "",
      dialogDetailTask: false,
      sendMailDialog: false,
      sendMailDetail: {},
      ListAlbumsDialog: false,
			ListAlbumsImage: [],
			ListAlbumsDetail: [],
      listfriend: [],
      space_key: " ",
      list_mention: [],
      listfriend_filter: [],
      search: "",
      loading: false,
      rows: 2,
      minRows: 2, // จำนวนแถวเริ่มต้น
			maxRows: 4, // จำนวนแถวสูงสุด (ตามต้องการ)
			maxCharsPerRow: 100,
      gotoReply: false,
      gotoBtm: false,
      gotoMsg: false,
      new_message: {},
      DetailAlbumsDialog: {},
      DetailAlbumsChatDialog: false,
      SendFileOneboxDialog: false,
      SendFileOneboxDetail: {},
      swipe_state: '',
      swipe_index: 0,
      list_announce: [],
      less: false,
      show: false,
      videoOptions: {
        autoplay: true,
        controls: true,
        muted: false
      },
      thumbnail_video: '',
      sources_video: [],
      ListForwardDialog: false,
      ListForwardDetail: [],
      statusForward: false,
      selectedForward: [],
      LocationDetail: '',
      LocationDialog: false,
      ListContactDialog: false,
      ListContactDetail: {},
      focusKey: false,
      selectSticker: true,
      tab: 'tab-1',
      tabemo: 'tab-1',
      emojiGroups,
      menuChat: false,
      menuChatBottom: false,
      marker: true,
      QrcodeInfor: {},
      dialogQrcodRichMenu: false,
      Richmenudialog: false,
      RichmenuState: false,
      sheetrichmenu: false,
      ListMenuData: '',
      WarningDialog: false,
      WarningDialogDetail: {},
      ErrorDialogDetail: {},
      ErrorDialog: false,
      ListBottomMenu: false,
      ListBottomItem: [],
      InforFriend: {},
      DetailFriendDialog: false,
      NoteChatDialog: false,
      NoteChatDetail: {},
      EditNoteChatDialog: false,
      DetailNoteChatDialog: false,
      NoteDetail: {},
      publicPath: process.env.VUE_APP_BASE_PATH,
      ChatRoomMenu: false,
      showmenu: true,
      dialogWebviewbig_ocr: false,
      Webview_item_ocr: {},
      statusload: true,
      isLoading: false,
      numPages: 1,
      urlpdf: '',
      filenamepdf: '',
      pictureRoom: '',
      nameRoom: '',
      typeRoom: '',
      data_user: {},
      tokenuser: '',
      one_id: '',
      tokenroom: '',
      typeuser: 'user',
      msgSend: '',
      profileSelf: 'https://chat-api.one.th/alpine/api/v1/file/1b93a561-ab93-4d90-80eb-ffe0f42afafc.jpg',
      scrollable: {
        'height': 'calc(100vh - 130px) !important'
      },
      stylechat: {
        "--Chat-Background": "white",
        "--Chat-HeaderColor": "white",
        "--Chat-HeaderBackground": "#2463af",
        "--Chat-HeaderPictureBorderRadius": "6px",
        "--Chat-ChatboxBackgroundOwner": "#34567f",
        "--Chat-ChatboxColorOwner": "white",
        "--Chat-ChatboxBorderOwner": "none",
        "--Chat-ChatboxBorderRadiusOwner": "6px",
        "--Chat-ChatboxColorNotSupportOwner": "#929292",
        "--Chat-ChatboxBackgroundOther": "#efefef",
        "--Chat-ChatboxColorOther": "#615f5f",
        "--Chat-ChatboxBorderOther": "none",
        "--Chat-ChatboxBorderRadiusOther": "6px",
        "--Chat-ChatboxColorNotSupportOther": "#b1b1b1",
        "--Chat-TypingboxBackground": "#2463af",
        "--Chat-TypingboxColor": "white",
        "--Chat-QuickReplyButtonBorder": "#2463af",
        "--Chat-QuickReplyButtonBackground": "white",
        "--Chat-QuickReplyButtonColor": "#2463af",
        "--Chat-Icon-Active": "white"
      },
      list_quickreply: [],
      height100: '100vh',
      detialroom: {},
      listchat: [],
      detailReadmore: {},
      dialogReadmore: false,
      Webview_item: {},
      dialogWebviewbig: false,
      backstatus: '',
      datepicker: false,
      timepicker: false,
      maxdate: '',
      mindate: '',
      maxtime: '',
      mintime: '',
      dateselect: '',
      timeselect: '',
      infodata: '',
      landscape: false,
      ocr_detailItem: {},
      itemdetail_quickreply: {},
      statemember: '',
      checkBrowserInfor: {},
      checkBrowserDialog: false,
      pageCount: 1,
      page: null,
      bot_id_richmenu: '',
      menuSticker: false,
      sticker: [],
      previewMessage: false,
      previewMessageInfor: {},
      reply_data: {},
      reply_status: false,
      temp: [],
      heightChat: 0,
      width_layout: 0,
    }
  },
  components: {
    VuePdfApp,
    vplayer,
    aplayer,
    QrCodeRichMenuDialog,
    ErrorDialog,
    WarningDialog,
    pdf,
    vue100vh,
    ReadmoreDialog,
    WebviewBigDialog,
    WebviewBigOcrDialog,
    CheckBrowserDialog,
    EditNoteChatDialog,
    DetailNoteChatDialog,
    NoteChat,
    DetailFriendDialog,
    LinkPrevue,
    VuePdfEmbed,
    ListBottomMenu,
    Richmenu,
    ListContact,
    SendLocation,
    ListForward,
    SendFileOnebox,
    DetailAlbums,
    ListAlbumChat,
    SendMail,
    DetailTask,
    // LinkPrevue
  },
  computed: {
     ...sync('*')
  },
  created() {
    // inner width
    this.width_layout = window.innerWidth
    // console.log(`this.width_layout: ${this.width_layout}`)
    this.backstatus = this.$route.query.backstatus
    // console.log(`this.backstatus: ${this.backstatus}`)
    this.tokenroom = this.$route.params.tokenroom
    // var user_profile = JSON.parse(this.$cookie.get('user-profile'))
    var user_profile = ''
    if (JSON.parse(this.$cookie.get('user-profile') == null)) {
      user_profile = JSON.parse(localStorage.getItem('user-profile'))
    } else {
      user_profile = JSON.parse(this.$cookie.get('user-profile'))
    }
    this.data_user = user_profile['account']['profile']
    // console.log('this.data_user: ', this.data_user);
    this.tokenuser = this.data_user.tokenuser
    this.heightChat = this.$vssHeight
    if (this.heightChat) {
      this.height100 = this.heightChat + 'px'
    }
    var announce = this.$cookie.get(this.$route.params.tokenroom)
    // console.log(announce)
    if(announce !== null) {
      this.less = true
    }
    // this.InputFocusCancel()
    this.getroom()
    this.getmessageHistory("")
    this.getreply()
    this.getListSticker()
    this.getListAnnonce()
  },
  watch: {
    '$vssHeight' () {
      console.log('$vssHeight: ', this.$vssHeight)
      // alert(this.$vssHeight)
    },
    msgSend () {
      this.checkContent();
			this.checkNewlines();
    },
    gotoMsg (val) {
      console.log("gotoMsg => ", val);
      // if (val) {
      //   this.scrollable = {
      //       'height': 'calc(' + this.height100 + ' - 150px) !important'
      //     }
      // } else if (this.gotoBtm) {
      //   this.scrollable = {
      //       'height': 'calc(' + this.height100 + ' - 150px) !important'
      //     }
      // } else {
      //   this.scrollable = {
      //       'height': 'calc(100vh - 130px) !important'
      //     }
      // }
      this.setHeightTyping(this.rows)
    },
    gotoBtm (val) {
      console.log("gotoBtm => ", val);
      // if (val && this.gotoMsg) {
      //   console.log("gotoBtm 1 => ", val);
      //   this.scrollable = {
      //       'height': 'calc(' + this.height100 + ' - 150px) !important'
      //     }
      // } else if (val) {
      //   console.log("gotoBtm 2 => ", val);
      //   this.scrollable = {
      //       'height': 'calc(' + this.height100 + ' - 150px) !important'
      //     }
      // } else {
      //   console.log("gotoBtm 3 => ", val);
      //   this.scrollable = {
      //       'height': 'calc(100vh - 130px) !important'
      //     }
      // }
      this.setHeightTyping(this.rows)
    },
    less () {
      if (this.less) {
        this.$cookie.set(this.$route.params.tokenroom, 'less')
      } else {
        this.$cookie.delete(this.$route.params.tokenroom)
      }
    },
    selectedForward () {
      // console.log(this.selectedForward)
      if (this.selectedForward.length > 5) {
        this.ErrorDialogDetail = {
          title: '',
          text: this.$t('Alert.Fail.Chat.maxMessage')
        }
        this.ErrorDialog = true
        _.pullAt(this.selectedForward, [5])
      }
    },
    socket_switch_richmenu () {
      // console.log(this.socket_switch_richmenu)
      if (this.socket_switch_richmenu.tokenroom === this.$route.params.tokenroom) {
        this.RichmenuState = true
        this.sheetrichmenu = true
        this.menuChat = false
      }
    },
    socket_switch_keyboard () {
      // console.log(this.socket_switch_keyboard)
      if (this.socket_switch_keyboard.tokenroom === this.$route.params.tokenroom) {
        this.RichmenuState = false
        this.sheetrichmenu = false
        this.menuChat = false
      }
    },
    socket_drop_menu() {
			// console.log("socket_drop_menu", this.socket_drop_menu);
			if (this.socket_drop_menu.tokenroom === this.$route.params.tokenroom) {
				this.RichmenuState = true
				this.sheetrichmenu = false
				this.menuChat = false
			}
		},
    menuChat () {
      if (this.menuChat) {
        this.scrollable = {
          'height': 'calc(' + this.height100 + ' - 200px) !important'
        }
      } else {
        // this.InputFocus(this.menuChat)
        // console.log(this.InputFocusCancel())
        if (this.menuSticker) {
          this.scrollable = {
            'height': 'calc(' + this.height100 + ' - 450px) !important'
          }
        } else {
          this.scrollable = {
            'height': 'calc(' + this.height100 + ' - 130px) !important'
          }
        }
      }
    },
    sheetrichmenu () {
      // console.log(this.height100)
      // console.log(this.$vssHeight);
      // console.log('window.innerWidth: ', window.innerWidth)
      // console.log('this.sheetrichmenu ', this.sheetrichmenu)
      if (this.$vssHeight >= 900 || this.width_layout > 500) {
        if (this.sheetrichmenu) {
          this.menuChat = false
          // console.log(parseInt(this.ListMenuData.type_menu) <= 7)
          if (this.list_quickreply.quick_reply) {
            if (parseInt(this.ListMenuData.type_menu) <= 7) {
              // console.log('obj 1')
              this.scrollable = {
                'height': 'calc(' + this.height100 + ' - 450px) !important'
              }
            } else {
              // console.log('obj 2')
              this.scrollable = {
                'height': 'calc(' + this.height100 + ' - 310px) !important'
              }
            }
          } else {
            if (parseInt(this.ListMenuData.type_menu) <= 7) {
              // console.log('obj 1.1')
              this.scrollable = {
                'height': 'calc(' + this.height100 + ' - 375px) !important'
              }
            } else {
              // console.log('obj 1.2')
              this.scrollable = {
                'height': 'calc(' + this.height100 + ' - 310px) !important'
              }
            }
          }
        } else {
          if (this.list_quickreply.quick_reply) {
            // console.log('obj 3')
            this.scrollable = {
              'height': 'calc(' + this.height100 + ' - 170px) !important'
            }
          } else {
            // console.log('obj 4')
            this.scrollable = {
              'height': 'calc(' + this.height100 + ' - 130px) !important'
            }
          }
        }
      } else {
        if (this.sheetrichmenu) {
          this.menuChat = false
          // console.log(parseInt(this.ListMenuData.type_menu) <= 7)
          if (this.list_quickreply.quick_reply) {
            if (parseInt(this.ListMenuData.type_menu) <= 7) {
              // console.log('obj 1')
              this.scrollable = {
                'height': 'calc(' + this.height100 + ' - 445px) !important'
              }
            } else {
              // console.log('obj 2')
              this.scrollable = {
                'height': 'calc(' + this.height100 + ' - 310px) !important'
              }
            }
          } else {
            if (parseInt(this.ListMenuData.type_menu) <= 7) {
              // console.log('obj 1.3')
              this.scrollable = {
                'height': 'calc(' + this.height100 + ' - 405px) !important'
              }
            } else {
              // console.log('obj 1.4')
              this.scrollable = {
                'height': 'calc(' + this.height100 + ' - 277px) !important'
              }
            }
          }
        } else {
          if (this.list_quickreply.quick_reply) {
            // console.log('obj 3')
            this.scrollable = {
              'height': 'calc(' + this.height100 + ' - 170px) !important'
            }
          } else {
            // console.log('obj 4')
            this.scrollable = {
              'height': 'calc(' + this.height100 + ' - 130px) !important'
            }
          }
        }
      }

    },
    socket_close_webview() {
      this.dialogWebviewbig_ocr = false
    },
    dateselect() {
      if (this.dateselect) {
        setTimeout(this.scrollToEnd, 1)
      }
    },
    timeselect() {
      if (this.timeselect) {
        setTimeout(this.scrollToEnd, 1)
      }
    },
    list_quickreply() {
      if (!this.list_quickreply.quick_reply) {
        this.scrollable = {
          'height': 'calc(' + this.height100 + ' - 130px) !important'
        }
      } else {
        this.scrollable = {
          'height': 'calc(' + this.height100 + ' - 185px) !important'
        }
      }
    },
    // urlpdf() {
    //   var me = this
    //   this.src = pdf.createLoadingTask(this.urlpdf).promise.then(result => {
    //     me.numPages = result.numPages
    //   }, (resolve) => {
    //     setTimeout(() => resolve('done!'), 1000)
    //   })
    // },
    socket_official_template(data) {
      // console.log(data)
      if (data.tokenroom === this.$route.params.tokenroom) {
        // console.log(data)
        var index_target = data.target_index
        var index = _.findIndex(this.listchat, function(o) {
          return o.tokenmessage == data.tokenmessage
        })
        this.listchat[index].element.choice[index_target].disable = '1'
      }
    },
    socket_unsendmessage(data) {
      if (data.tokenroom === this.$route.params.tokenroom) {
        var indexid = _.findIndex(this.listchat, function(o) {
          return o.tokenmessage === data.tokenmessage
        })
        var mentiontokenmessage = this.listchat[indexid].tokenmessage
        var indexmentionmsg = _.findIndex(this.listchat, function(o) {
          return o.file_name === mentiontokenmessage
        })
        if (indexmentionmsg === -1) {
          this.listchat[indexid].typeofmessage = 'unsend_message'
        } else {
          this.listchat[indexid].typeofmessage = 'unsend_message'
          this.listchat[indexmentionmsg].source_message.typeofmessage = 'unsend_message'
        }
      }
    },
    socketmessage(data) {
      // console.log(data)
      // this.scrollable = {
      //   'height': 'calc(' + this.height100 + ' - 130px) !important'
      // }
      this.setHeightTyping(this.rows)
      if (data !== null) {
        if (data.tokenuser !== this.tokenuser) {
        if (data.tokenroom === this.tokenroom) {
						this.gotoMsg = true
						this.new_message = data
					}
        this.axios.post(process.env.VUE_APP_API_alpine + '/v1/user-mark-read', {
          tokenuser: this.tokenuser,
          tokenroom: data.tokenroom
        }).then((response) => {})
      }
      this.insertMessage(data, data.tokenmessage)
      }
    },
    socketquickreply(data) {
      // console.log(data)
      if (data.tokenroom === this.$route.params.tokenroom) {
        // console.log(data)
        // this.getreply()
        this.datepicker = false
        this.timepicker = false
        this.maxdate = ''
        this.mindate = ''
        this.maxtime = ''
        this.mintime = ''
        this.dateselect = ''
        this.timeselect = ''
        this.infodata = ''
        this.list_quickreply = data
      }
    },
    socketdisablequickreply(data) {
      if (data.tokenroom === this.$route.params.tokenroom) {
        // console.log(data)
        this.datepicker = false
        this.timepicker = false
        this.maxdate = ''
        this.mindate = ''
        this.maxtime = ''
        this.mintime = ''
        this.dateselect = ''
        this.timeselect = ''
        this.infodata = ''
        this.list_quickreply = ''
      }
    },

  },
  methods: {
    closeDetailTask (val) {
      this.dialogDetailTask = val
      this.taskid = ""
    },
    checkPriorityTask(value) {
			if (value === '1') {
				return '#b3493d';
			} else if (value === '2') {
				return '#fcbe54';
			} else {
				return '#a0a1a3';
			}
		},
    handleClick (e) {
      // console.log("handleClick =>", e);
      const username = e.target.innerHTML.substring(1)
      const myUser = localStorage.name !== undefined ? localStorage.name : this.data_user.name
      // console.log(myUser)
      // console.log(username);
      var item = {}
      if (username !== myUser) {
        this.listfriend.forEach(freind =>{
          // var item = []
          const rex = /[\u{1f300}-\u{1f5ff}\u{1f900}-\u{1f9ff}\u{1f600}-\u{1f64f}\u{1f680}-\u{1f6ff}\u{2600}-\u{26ff}\u{2700}-\u{27bf}\u{1f1e6}-\u{1f1ff}\u{1f191}-\u{1f251}\u{1f004}\u{1f0cf}\u{1f170}-\u{1f171}\u{1f17e}-\u{1f17f}\u{1f18e}\u{3030}\u{2b50}\u{2b55}\u{2934}-\u{2935}\u{2b05}-\u{2b07}\u{2b1b}-\u{2b1c}\u{3297}\u{3299}\u{303d}\u{00a9}\u{00ae}\u{2122}\u{23f3}\u{24c2}\u{23e9}-\u{23ef}\u{25b6}\u{23f8}-\u{23fa}]/ug;
          var x = username.replace(rex, match => `[e-${match.codePointAt(0).toString(16)}]`)
          var y = freind.name.replace(rex, match => `[e-${match.codePointAt(0).toString(16)}]`)
          // console.log(x)
          // console.log(y)
          // console.log(x.includes(y))
          if(x.includes(y)){
          // console.log(freind)
          const tokenUser = freind.tokenuser
          item.tokenuser = tokenUser
          this.openDialog(item, 'detailfriend')
          }
        })
      } else {
        item.tokenuser = this.tokenuser
        this.openDialog(item, 'detailfriend')
      }
    },
    convertMsg (msg) {
      msg = msg.replace(/\<tax>/g,'<span style="color:#1976d2; cursor:pointer;">@');
      msg = msg.replace(/<\/tax>/g,'</span>');
      // console.log(msg)
      return msg
    },
    convertMsgMention (msg, listmemtion) {
			for (var j = 0; j < listmemtion.length; j++) {
				if (listmemtion[j] !== undefined) {
					msg = msg.replace(('@' + listmemtion[j].name), '<tax>' + listmemtion[j].tokenuser + '</tax>')
				}
			}
			return msg
		},
    setHeightTyping (row) {
      var typerMenu = this.$refs.typerMenu;
      // console.log("typerMenu", typerMenu);
      if (typerMenu !== null && typerMenu !== undefined) {
        if (this.gotoBtm || this.gotoMsg) {
          if (row === 2) {
            this.scrollable = {
              'height': 'calc(' + this.height100 + ' - 150px) !important'
            }
            typerMenu.style.height = '75px'
          } else if (row === 3) {
            this.scrollable = {
              'height': 'calc(' + this.height100 + ' - 170px) !important'
            }
            typerMenu.style.height = '100px'
          } else if (row === 4) {
            this.scrollable = {
              'height': 'calc(' + this.height100 + ' - 180px) !important'
            }
            typerMenu.style.height = '105px'
          } else {
            this.scrollable = {
              'height': 'calc(' + this.height100 + ' - 130px) !important'
            }
            typerMenu.style.height = '75px'
          }
        } else {
          if (row === 2) {
            this.scrollable = {
              'height': 'calc(' + this.height100 + ' - 130px) !important'
            }
            typerMenu.style.height = '75px'
          } else if (row === 3) {
            this.scrollable = {
              'height': 'calc(' + this.height100 + ' - 150px) !important'
            }
            typerMenu.style.height = '100px'
          } else if (row === 4) {
            this.scrollable = {
              'height': 'calc(' + this.height100 + ' - 160px) !important'
            }
            typerMenu.style.height = '105px'
          } else {
            this.scrollable = {
              'height': 'calc(' + this.height100 + ' - 130px) !important'
            }
            typerMenu.style.height = '75px'
          }
        } 
      } 
      // else {
      //   if (this.sheetrichmenu) {
      //     console.log("object 1");
      //     const sheetrichmenu = this.$refs.sheetrichmenu;
      //     console.log(sheetrichmenu);
      //     if (this.gotoBtm) {
      //       console.log(`"btnBackMsg" ${this.gotoBtm}`, this.$refs.btnBackMsg);
      //     }
      //     // typerMenu = sheetrichmenu;
      //     // typerMenu.style.height = '200px'
      //     // console.log(" typerMenu.style.height",  typerMenu.style.height);
      //   } else {
      //     console.log("object 2");
      //   }
      // }
    },
    checkContent() {
			// นับจำนวนตัวอักษรในข้อความ
			const charCount = this.msgSend.length;

			// คำนวณจำนวนแถวที่ต้องใช้ (หารความยาวของข้อความด้วยจำนวนตัวอักษรที่รองรับใน 1 แถว)
			const calculatedRows = Math.ceil(charCount / this.maxCharsPerRow);

			// เพิ่ม rows ตามความยาวของข้อความ แต่ไม่เกิน maxRows
			this.rows = Math.min(Math.max(calculatedRows, this.minRows), this.maxRows);
			// console.log("this.rows =>", this.rows);
			if (this.rows <= 4) {
				this.setHeightTyping(this.rows)
			}
		},
		checkNewlines() {
			// console.log("checkNewlines");
			// นับจำนวน \n ในข้อความ
			const newlineCount = (this.msgSend.match(/\n/g) || []).length;
			// เพิ่ม row เมื่อ \n มากกว่า 4
			if (newlineCount > 4) {
				this.rows = Math.min(newlineCount + 1, this.maxRows); // จำกัดไม่เกิน maxRows
			} else {
				this.rows = this.minRows; // ตั้งค่า row กลับเป็นค่าเริ่มต้น
			}
			if (this.rows <= 4) {
				this.setHeightTyping(this.rows)
			}
		},
    setDefaultImageChat (id) {
      var img = document.getElementById(`imgprofilechat-${id}`);
      img.src = `${require(`${this.publicPath}/assets/img/default_profile/man-white.png`)}`
      img.alt = "Default Image Alt Text";
    },
    onSelect(option) {
			// console.log('onSelect -> ', option);
			this.tag_id = `-${option.children[1].elm.id}`
			var tag_name = option.value.split('-')[0]
			const searchStrings = option.value;
			const startIndex = this.msgSend.indexOf(searchStrings) // หา index mention เพื่อเรียง list_mention
			this.list_mention.push({
				index: startIndex,
				name: tag_name,
				tokenuser: option.children[1].elm.id
			})
			this.list_mention = _.sortBy(this.list_mention, ['index'])
      // console.log("list_mention", this.list_mention);
			const searchString = this.tag_id;
			this.msgSend = this.msgSend.replace(new RegExp(searchString, 'g'), '');
		},
		onSearch(search) {
			// console.log("listfriend", this.listfriend);
			if (this.typeRoom === 'group') {
				// console.log('onSearch -> ', search);
				this.search = search;
				this.loading = true;
				if (!search) {
          var me = this
					// If the search query is empty, reset the filtered list to show all members
					this.listfriend_filter = _.filter(this.listfriend, function(o) { return o.tokenuser !== me.tokenuser });
					this.loading = false;
					return;
				}
				// Filter members based on the search query
				this.listfriend_filter = this.listfriend.filter(user =>
					// this.app_lang === "en" && user.name_eng !== "" ? user.name_eng.toLowerCase().includes(search.toLowerCase()) :
					// 	user.name.toLowerCase().includes(search.toLowerCase())
					user.name.toLowerCase().includes(search.toLowerCase())
				);
				this.loading = false;
			}
		},
    gotoBtmMsg () {
      console.log("gotoBtmMsg");
			this.$nextTick(() => {
				this.gotoMessage(this.listchat[this.listchat.length - 1].tokenmessage)
			})
    },
    btn_answer_carousel (item) {
      if (item.type === 'webview' || item.type === 'link') {
				var infor = {
				sign: item.sign,
				url: item.action,
				type: item.type,
				label: item.button,
				onechat_token: item.onechat_token,
				payload: item.payload,
				size: 'full'
				}
				this.check_authen(infor)
			} else if (item.type === 'link_market') {
				this.$swal({
					type: "warning",
					text: this.$t('Alert.Warning.link_market'),
					showConfirmButton: true,
					allowOutsideClick: false,
					confirmButtonText: this.$t('AnswerQuestion.ok')
				})
			} else {
				this.ans_carousel(item)
			}
		},
		ans_carousel (item) {
			var payload = {}
			if (item.payload !== undefined) {
				payload = item.payload
			}
			var body = {
				tokenuser: this.tokenuser,
				tokenroom: this.tokenroom,
				action: item.action,
				type: item.type,
				payload: payload
			}
			this.axios.post(process.env.VUE_APP_API_ALPINE + '/api/v1/ansCarousel', body).then((response) => {
				// console.log(response.data)
			}).catch(error => {
				console.log(error)
			})
		},
    announceMsg (item) {
      // console.log(item)
      var body = {
        tokenmessage: item.tokenmessage,
        tokenuser: this.tokenuser,
        tokenroom: this.$route.params.tokenroom
      }
      this.axios.post(process.env.VUE_APP_API_EVENT + `/v1/user/announce_room`, body, {
      }).then((response) => {
        // console.log(response.data)
        if (response.data.status == 'success') {
          this.getListAnnonce()
        }
      }).catch(err => {
        console.log(err)
        this.ErrorDialogDetail = {
          title: 'Error',
          text: this.$t('Alert.Fail.default.somethingWrong')
        }
        this.ErrorDialog = true
      })
    },
    delete_announce () {
      var body = {
        tokenroom: this.$route.params.tokenroom,
        tokenuser: this.tokenuser
      }
      this.axios.post(process.env.VUE_APP_API_EVENT + `/v1/user/disable_announce_room`, body, {
      }).then((response) => {
        // console.log(response.data);
        if (response.data.status == 'success') {
          this.list_announce = []
          this.swipe_index = 0
          this.swipe_state = ''
        }
      }).catch(err => {
        console.log(err)
        this.ErrorDialogDetail = {
          title: 'Error',
          text: this.$t('Alert.Fail.default.somethingWrong')
        }
        this.ErrorDialog = true
      })
    },
    deleteAnnounceId (id, idx) {
      var body = {
        token_announce: id,
        tokenroom: this.$route.params.tokenroom,
        tokenuser: this.tokenuser
      }
      this.axios.post(process.env.VUE_APP_API_EVENT + `/v1/user/disable_single_announce_room`, body, {
      }).then((response) => {
        // console.log(response.data);
        if (response.data.status == 'success') {
          this.list_announce.splice(idx, 1)
          this.swipe_index = 0
          this.swipe_state = ''
        }
      }).catch(err => {
        console.log(err)
        this.ErrorDialogDetail = {
          title: 'Error',
          text: this.$t('Alert.Fail.default.somethingWrong')
        }
        this.ErrorDialog = true
      })
    },
    swipe (type, idx) {
      // console.log(type)
      // console.log(idx)
      this.swipe_state = type
      this.swipe_index = idx
    },
    getListAnnonce () {
      var body = {
        tokenroom: this.$route.params.tokenroom,
        tokenuser: this.tokenuser
      }
      this.axios.post(process.env.VUE_APP_API_EVENT + `/v1/user/get_announce_room`, body, {
      }).then((response) => {
        if (response.data.status == 'success') {
          this.list_announce = _.reverse(response.data.data)
          // console.log(this.list_announce)
        }
      }).catch(err => {
        console.log(err)
        this.ErrorDialogDetail = {
          title: 'Error',
          text: this.$t('Alert.Fail.default.somethingWrong')
        }
        this.ErrorDialog = true
      })
    },
    isInputMsg (evt) {
      // console.log(evt)
      // //keyboard maping array
      // var keyboardMap = ["DONE", "", "", "CANCEL", "", "", "HELP", "", "BACK_SPACE", "TAB", "", "", "CLEAR", "ENTER", "RETURN", "", "SHIFT", "CONTROL", "ALT", "PAUSE", "CAPS_LOCK",
      // "KANA", "EISU", "JUNJA", "FINAL", "HANJA", "", "ESCAPE", "CONVERT", "NONCONVERT", "ACCEPT", "MODECHANGE", "SPACE", "PAGE_UP", "PAGE_DOWN", "END", "HOME", "LEFT", "UP", "RIGHT", "DOWN",
      // "SELECT", "PRINT", "EXECUTE", "PRINTSCREEN", "INSERT", "DELETE", "", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "COLON", "SEMICOLON", "LESS_THAN",
      // "EQUALS", "GREATER_THAN", "QUESTION_MARK", "AT", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P",
      // "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "WIN", "", "CONTEXT_MENU", "", "SLEEP", "NUMPAD0", "NUMPAD1", "NUMPAD2", "NUMPAD3", "NUMPAD4", "NUMPAD5", "NUMPAD6", "NUMPAD7", "NUMPAD8", "NUMPAD9", "MULTIPLY", "ADD", "SEPARATOR", "SUBTRACT", "DECIMAL", "DIVIDE", "F1", "F2", "F3", "F4", "F5", "F6", "F7", "F8", "F9", "F10", "F11", "F12", "F13", "F14", "F15", "F16", "F17", "F18", "F19", "F20", "F21", "F22", "F23", "F24", "", "", "", "", "", "", "", "", "NUM_LOCK", "SCROLL_LOCK", "WIN_OEM_FJ_JISHO", "WIN_OEM_FJ_MASSHOU", "WIN_OEM_FJ_TOUROKU", "WIN_OEM_FJ_LOYA", "WIN_OEM_FJ_ROYA", "", "", "", "", "", "", "", "", "", "CIRCUMFLEX", "EXCLAMATION", "DOUBLE_QUOTE", "HASH", "DOLLAR", "PERCENT", "AMPERSAND", "UNDERSCORE", "OPEN_PAREN", "CLOSE_PAREN", "ASTERISK", "PLUS", "PIPE", "HYPHEN_MINUS", "OPEN_CURLY_BRACKET", "CLOSE_CURLY_BRACKET", "TILDE", "", "", "", "", "VOLUME_MUTE", "VOLUME_DOWN", "VOLUME_UP", "", "", "", "", "COMMA", "", "PERIOD", "SLASH", "BACK_QUOTE", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "OPEN_BRACKET", "BACK_SLASH", "CLOSE_BRACKET", "QUOTE", "", "META", "ALTGR", "", "WIN_ICO_HELP", "WIN_ICO_00", "", "WIN_ICO_CLEAR", "", "", "WIN_OEM_RESET", "WIN_OEM_JUMP", "WIN_OEM_PA1", "WIN_OEM_PA2", "WIN_OEM_PA3", "WIN_OEM_WSCTRL", "WIN_OEM_CUSEL", "WIN_OEM_ATTN", "WIN_OEM_FINISH", "WIN_OEM_COPY", "WIN_OEM_AUTO", "WIN_OEM_ENLW", "WIN_OEM_BACKTAB", "ATTN", "CRSEL", "EXSEL", "EREOF", "PLAY", "ZOOM", "", "PA1", "WIN_OEM_CLEAR", ""];
      // //Allowed keys as per your requirement
      // var allowedKey = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "NUMPAD0", "NUMPAD1", "NUMPAD2", "NUMPAD3", "NUMPAD4", "NUMPAD5", "NUMPAD6", "NUMPAD7", "NUMPAD8",
      //  "NUMPAD9", "DELETE", "BACK_SPACE", "DECIMAL", "LEFT", "RIGHT", "TAB", "SUBTRACT", "PERIOD"];
      // // alert(`key1: ${evt.key} | code1: ${evt.code} | keyCode1: ${evt.keyCode}`)
      // var key = evt.charCode || evt.keyCode || 0;
      // var keyValue = keyboardMap[key];
      // if ($.inArray(keyValue, allowedKey) !== -1) {
      //     return true;
      // }
      // else {
      //     return  false;
      // }
      alert(`key2: ${evt.key} | code1: ${evt.code} | keyCode1: ${evt.keyCode} | cancelBubble: ${evt.cancelBubble}`)
    },
    cancelForward () {
      this.selectedForward = []
      this.temp = []
      this.statusForward = false
    },
    previewSticker (message) {
      // console.log(message)
      this.previewMessage = true
      this.previewMessageInfor = message
    },
    sendSticker (message) {
      // console.log(message)
      this.axios.post(process.env.VUE_APP_API_message + '/push_sticker', {
        tokenroom: this.$route.params.tokenroom,
        tokenuser: this.tokenuser,
        message: message,
        type: 'user',
        business_id: null
      }).then((response) => {
        var messageSendChat = response.data.data
        if (response.data.status === 'success') {
          this.menuSticker = false
          this.selectSticker = true
          this.marker = true
          var messageSendChat = response.data.data
          this.insertMessage(messageSendChat, messageSendChat.tokenmessage)
        }
      })
    },
    append (emoji) {
      this.msgSend += emoji
    },
    showSticker (value) {
      this.selectSticker = value
    },
    getListSticker () {
      this.axios.post(process.env.VUE_APP_API_message + '/sticker/gettitleallsticker', {tokenuser: this.tokenuser}).then((responsed) => {
        this.sticker = responsed.data['data']
        // console.log(this.sticker)
      })
    },
    chsheetsticker (evt) {
      // console.log('sticker')
      // console.log(evt)
      this.menuSticker = !this.menuSticker
      this.menuChat = false
      this.marker = !this.marker
      // console.log('marker: ', this.marker)
      if (!this.marker) {
        // this.scrollable = {
        //   'height': 'calc(' + this.height100 + ' - 490px) !important'
        // }
        // this.InputFocus(evt)
      } else {
        this.tab = 'tab-1'
        this.selectSticker = true
      }
      // else {
      //   this.scrollable = {
      //     'height': 'calc(' + this.height100 + ' - 130px) !important'
      //   }
      // }

      // document.getElementById('tabsticker').click()
      // this.sheetsticker = !this.sheetsticker
    },
    showMenuChat (value) {
      // this.menuChat = value
      this.menuChatBottom = value
      if (!this.menuChat) {
        this.menuChat = false
        this.menuSticker = false
        this.marker = true
        this.selectSticker = true
      }
    },
    closedialogQrcode (value) {
      this.dialogQrcodRichMenu = value
    },
    stateRichmenu (value) {
      this.sheetrichmenu = value
      this.RichmenuState = value
      this.menuChat = false
    },
    showRichMenu (value) {
      // console.log(value)
      this.sheetrichmenu = value
    },
    emitrichmenu (item) {
      // console.log(item)
      var today = new Date()
      var dd = String(today.getDate()).padStart(2, '0')
      var hour = String(today.getHours() + 1).padStart(2, '0')
      var minute = String(today.getMinutes()).padStart(2, '0')
      var seconds = String(today.getSeconds()).padStart(2, '0')
      var milsec = today.getMilliseconds()
      var mm = String(today.getMonth() + 1).padStart(2, '0')
      var yyyy = today.getFullYear()
      // เช็คเวลาช่วงเที่ยงคืน ให้บวกค่าวันไปด้วย
      if (hour === '24') {
        hour = '00'
        dd = String(today.getDate() + 1).padStart(2, '0')
        var date_of_month = new Date(yyyy, mm + 1, 0).getDate()
        // เช็ควันที่บวกว่าเป็นวันสุดท้ายของเดือน?
        if (parseInt(dd) === date_of_month) {
          // ถ้าเป็นวันสุดท้ายของเดือนในเซตวันเป็นวันที่ 1
          dd = '1'
          // เช็คเดือนว่าเป็นเดือนสุดท้ายของปี?
          if (mm === '12') {
            // ถ้าเป็นเดือนสุดท้ายในเซตเป็นเดือน 1แล้วก็บวกปีเพิ่ม
            mm = '1'
            yyyy = today.getFullYear() + 1
          } else {
            // ไม่ใช่เดือนสุดท้ายก็บวกเดือนเพิ่มมา 1 เดือน (+2 เพราะว่าเดือนมันเริ่มที่ 0 getMonth ล่่าสุดมาแล้ว คือ +1 แล้วบวกไปอีก 1 เลยเป็น +2)
            mm = String(today.getMonth() + 2).padStart(2, '0')
            // console.log(mm)
          }
        }
      }
      today = yyyy + '-' + mm + '-' + dd + 'T' + hour + ':' + minute + ':' + seconds + '.' + milsec + 'Z'
      // console.log(today)

      var expireddate = Date.parse(today)
      var body = Encode.encodeRichmenu({ 'userid': this.tokenuser, 'expired_date': expireddate })
      // var url = '?onechat_token=' + body + '&' + 'expired_date=' + expireddate
      // var weburl = item.url + url
      var url = ''
      if (_.includes(item.url, ['?'])) {
        url = '&'
      } else {
        url = '?'
      }
      var weburl = item.url + url + 'onechat_token=' + body + '&' + 'expired_date=' + expireddate
      // console.log(weburl)
      if (item.type === 'text') {
        this.sendMessage(item.message)
      } else if (item.type === 'link') {
        if (item.sign_share === 'true') {
          this.getSign(item.url, item, this.bot_id_richmenu)
        } else if (item.sign === 'true') {
          // this.checkBrowser(weburl, item)
          try {
            const data_sign = { message: weburl }
            window.flutter_inappwebview.callHandler('op_openwebview', data_sign);
          } catch (e) {
            this.checkBrowser(weburl, item)
          }
        }
         else {
          // this.checkBrowser(item.url, item)
          try {
            const data_sign = { message: item.url }
            window.flutter_inappwebview.callHandler('op_openwebview', data_sign);
          } catch (e) {
            this.checkBrowser(item.url, item)
          }
        }
      } else if (item.type === 'webview') {
        if (item.sign_share === 'true') {
          this.getSign(item.url, item, this.bot_id_richmenu)
        } else if (item.sign === 'true') {
          var infor_webview = {
            message: item.message,
            picture: item.picture,
            sign: item.sign,
            size: item.size,
            type: item.type,
            url: weburl
          }
          this.Webview_item = infor_webview
          this.dialogWebviewbig = true
        } else {
          this.Webview_item = item
          this.dialogWebviewbig = true
        }
      }  else if (item.type === 'link_market') {
        // this.$swal('', 'ขออภัย ข้อความนี้ไม่รองรับการใช้งานบนเว็บไซต์', 'warning')
        this.ErrorDialogDetail = {
          title: 'Warning',
          text: this.$t('Alert.Warning.link_market')
        }
        this.ErrorDialog = true

      } else if (item.type === 'location') {
        // console.log('rich menu type location')
        // console.log(window.navigator.geolocation)
        var me = this
        if (window.navigator.geolocation) {
          window.navigator.geolocation.getCurrentPosition(function(position) {
              // me.send_location(position.coords.latitude, position.coords.longitude, '')
              const lat = position.coords.latitude;
              const lon = position.coords.longitude;
              // ใช้ Google Maps Geocoding API
              const apiKey = "AIzaSyBUh61FWG3kr4BSAEO_NRrniSz8S5ceLic";
              const language = me.$i18n.locale !== undefined ? me.$i18n.locale : 'th'; // ภาษาไทย
              const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lon}&language=${language}&key=${apiKey}`;
              
              fetch(url)
                .then((response) => response.json())
                .then((data) => {
                  if (data.results.length > 0) {
                    // console.log("สถานที่:", data.results[0]);
                    me.send_location(position.coords.latitude, position.coords.longitude, data.results[0].formatted_address)
                  } else {
                    console.log("ไม่พบข้อมูลสถานที่");
                    me.send_location(position.coords.latitude, position.coords.longitude, '')
                  }
                })
                .catch((error) => console.error("Error:", error));
          },
          function(error) {
            console.log(error)
            me.ErrorDialogDetail = {
              title: 'Warning',
              text: 'Onechat needs access to use your current location, Please allow your location.'
            }
            me.ErrorDialog = true
          })
        }
      } else if (item.type === 'qrcode' && item.location_status === 'false') {
        // console.log('rich menu type qrcode')
        this.dialogQrcodRichMenu = true
        this.QrcodeInfor = { status: item.location_status, lat: '', lng: '', address: '' }
      } else if (item.type === 'qrcode' && item.location_status === 'true') {
        // console.log('rich menu qrcode location')
        this.dialogQrcodRichMenu = true
        var me = this
        if (window.navigator.geolocation) {
          window.navigator.geolocation.getCurrentPosition(function(position) {
            // me.QrcodeInfor = { status: item.location_status, lat: position.coords.latitude, lng: position.coords.longitude, address: '' }
              const lat = position.coords.latitude;
              const lon = position.coords.longitude;
              // ใช้ Google Maps Geocoding API
              const apiKey = "AIzaSyBUh61FWG3kr4BSAEO_NRrniSz8S5ceLic";
              const language = me.$i18n.locale !== undefined ? me.$i18n.locale : 'th'; // ภาษาไทย
              const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lon}&language=${language}&key=${apiKey}`;
              
              fetch(url)
                .then((response) => response.json())
                .then((data) => {
                  if (data.results.length > 0) {
                    // console.log("สถานที่:", data.results[0]);
                    me.QrcodeInfor = { status: item.location_status, lat: position.coords.latitude, lng: position.coords.longitude, address: data.results[0].formatted_address }
                  } else {
                    console.log("ไม่พบข้อมูลสถานที่");
                    me.QrcodeInfor = { status: item.location_status, lat: position.coords.latitude, lng: position.coords.longitude, address: '' }
                  }
                })
                .catch((error) => console.error("Error:", error));
          },
          function(error) {
            console.log(error)
            me.ErrorDialogDetail = {
              title: 'Warning',
              text: 'Onechat needs access to use your current location, Please allow your location.'
            }
            me.ErrorDialog = true
          })
          me.QrcodeInfor = { status: item.location_status, lat: '', lng: '', address: '' }
        }
      }
    },
    closeAlertDialog(item) {
      // console.log(item)
      if (item.type === 'bottommenu') {
        this.ListBottomMenu = item.value
      } else if (item.type === 'err') {
        this.ErrorDialog = item.value
      } else if (item.type === 'warning') {
        this.WarningDialog = item.value
      }
    },
    emitListBottom(item) {
      var value = item.item.value
      if (item.item.methods === 'image' || item.item.methods === 'video') {
        this.zoom(value)
      } else if (item.item.methods === 'cancel') {
        this.WarningDialogDetail = {
          title: this.$t('Alert.Sure'),
          text: this.$t('Alert.Chat.unsent', {
            name: item.item.methods
          }),
          detail: item,
          index: ''
        }
        this.WarningDialog = true
      } else if (item.item.methods === 'file') {
        this.openFilePDF(value)
      } else if (item.item.methods === 'download') {
        if (value.typeofmessage == 'video') {
          this.downloadFile(value.original_file, value.file_name)
        } else {
          this.downloadFile(value.message, value.file_name)
        }
      } else if (item.item.methods === 'mention') {
        this.RichmenuState = false
        this.sheetrichmenu = false
        this.reply_data = value
        this.reply_status = true
      } else if (item.item.methods === 'openmap') {
        this.LocationDetail = value
        this.LocationDialog = true
      } else if (item.item.methods === 'forward') {
        this.statusForward = true
        this.menuChat = false
        this.RichmenuState = false
        this.sheetrichmenu = false
        // this.selectedForward = this.temp
        this.selectedForward = [item.item.value.tokenmessage]
        this.temp = this.selectedForward
        // console.log(this.selectedForward)
      } else if (item.item.methods === 'announce') {
        this.announceMsg(value)
      } else if (item.item.methods === 'onebox') {
        // console.log(item.item.value)
        this.SendFileOneboxDetail = item.item.value
        this.SendFileOneboxDialog = true
      } else if (item.item.methods === 'album') {
        this.ListAlbumsDialog = true
				this.ListAlbumsImage = [item.item.value.message]
				this.ListAlbumsDetail = [item.item.value]
      } else if (item.item.methods === 'mail') {
        this.sendMailDialog = true
        this.sendMailDetail = item.item.value
      }
    },
    emitWarning(item) {
      // console.log(item)
      this.WarningDialog = false
      if (item.detail.item.methods === 'cancel') {
        this.cancelMessage(item.detail.item.value)
      }
    },
    cancelMessage(item) {
      // console.log(item)
      this.axios.post(process.env.VUE_APP_API_message + `/delete_message`, {
        tokenmessage: item.tokenmessage,
        tokenuser: this.tokenuser
      }).then((response) => {
        if (response.data.status === 'success') {
          // console.log(response.data)
        } else {
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        }
      }).catch(err => {
        console.log(err)
        this.ErrorDialogDetail = {
          title: 'Error',
          text: this.$t('Alert.Fail.default.somethingWrong')
        }
        this.ErrorDialog = true
      })
    },
    messageMenu (item, menu) {
      // console.log(menu)
      this.ListBottomItem = []
      if (this.statemember === 'active' && !this.statusForward) {
        if (menu.includes('image')) {
          this.ListBottomItem.push({
            text: this.$t('ChatSide.RightClickMenu.openimage'),
            methods: 'image',
            icon: '',
            value: item
          })
        }
        if (menu.includes('file')) {
          this.ListBottomItem.push({
            text: this.$t('ChatSide.RightClickMenu.openfile'),
            methods: 'file',
            icon: '',
            value: item
          })
        }
        if (menu.includes('video')) {
          this.ListBottomItem.push({
            text: this.$t('ChatSide.RightClickMenu.openvideo'),
            methods: 'video',
            icon: '',
            value: item
          })
        }
        if (menu.includes('openmap')) {
          this.ListBottomItem.push({
            text: this.$t('ChatSide.RightClickMenu.openlocation'),
            methods: 'openmap',
            icon: '',
            value: item
          })
        }
        if (menu.includes('download')) {
          this.ListBottomItem.push({
            text: this.$t('AnswerQuestion.download'),
            methods: 'download',
            icon: '',
            value: item
          })
        }
        if (item.type !== 'bot') {
          if (menu.includes('mention')) {
            this.ListBottomItem.push({
              text: this.$t('ChatSide.RightClickMenu.mention'),
              methods: 'mention',
              icon: '',
              value: item
            })
          }
        }
        if (menu.includes('cancel')) {
          this.ListBottomItem.push({
            text: this.$t('ChatSide.RightClickMenu.cancelMsg'),
            methods: 'cancel',
            icon: '',
            value: item
          })
        }
        if (menu.includes('announce')) {
          this.ListBottomItem.push({
            text: this.$t('ChatSide.RightClickMenu.announce'),
            methods: 'announce',
            icon: '',
            value: item
          })
        }
        if (menu.includes('forward')) {
          this.ListBottomItem.push({
            text: this.$t('ChatSide.RightClickMenu.forward'),
            methods: 'forward',
            icon: '',
            value: item
          })
        }
        if (menu.includes('album')) {
          this.ListBottomItem.push({
            text: this.$t('ChatSide.RightClickMenu.addImageAlbum'),
            methods: 'album',
            icon: '',
            value: item
          })
        }
        if (menu.includes('onebox')) {
          this.ListBottomItem.push({
            text: this.$t('HeaderMenubar.sendOnebox'),
            methods: 'onebox',
            icon: '',
            value: item
          })
        }
        if (menu.includes('mail')) {
          this.ListBottomItem.push({
            text: this.$t('Dialog.sendEmail.header'),
            methods: 'mail',
            icon: '',
            value: item
          })
        }
        // console.log(this.ListBottomItem)
        if (this.ListBottomItem.length !== 0) {
          this.ListBottomMenu = true
          this.DetailFriendDialog = false
        }
      }
    },
    handleDocumentRender() {
      // this.isLoading = false
      this.pageCount = this.$refs.myPdfComponent.pageCount
    },
    handlePasswordRequest(callback, retry) {
      callback(prompt(retry ?
        'Enter password again' :
        'This document is password protected. Please enter a password.'
      ))
    },
    clicklink_website(url) {
      // this.checkBrowser(url, '')
      try {
        const data_sign = { message: url }
        window.flutter_inappwebview.callHandler('op_openwebview', data_sign);
      } catch (e) {
        this.checkBrowser(url, item)
      }
    },
    closeDialog(data) {
      // console.log('close: ', data.name)
      if (data.name === 'DetailFriend') {
        this.DetailFriendDialog = data.value
      } else if (data.name === 'DetailFriendChat') {
        this.DetailFriendDialog = data.value
        this.tokenroom = this.$route.params.tokenroom
        this.detialroom = {}
        this.listchat = []
        this.getroom()
        this.getmessageHistory("")
      }
    },
    closeComponents(data) {
      // console.log(data)
      this.menuChatBottom = false
      if (data.name === 'edit-note') {
        this.EditNoteChatDialog = data.value
      } else if (data.name === 'detail-note') {
        this.DetailNoteChatDialog = data.value
      } else if (data.name === 'notechat') {
        this.NoteChatDialog = data.value
      } else if (data.name === "listcontact") {
        this.ListContactDialog = data.value
      } else if (data.name === "sendlocation") {
        this.LocationDialog = data.value
        this.LocationDetail = ''
      } else if (data.name === "ListForward") {
        this.ListForwardDialog = data.value
        this.ListForwardDetail = []
      } else if (data.name === 'sendonebox') {
        this.SendFileOneboxDetail = {}
        this.SendFileOneboxDialog = data.value
      } else if (data.name === 'detail-album' || data.name === 'delete-album') {
        this.DetailAlbumsDialog = {}
        this.DetailAlbumsChatDialog = data.value
      }  else if (data.name === 'list-albumschat') {
				this.ListAlbumsDialog = data.value
				this.ListAlbumsDetail = []
				this.ListAlbumsImage = []
			} else if (data.name === 'send-mail') {
        this.sendMailDialog = data.value
        this.sendMailDetail = {}
      }
    },
    emitComponents(value) {
      // console.log(value)
      if (value.name === 'detail-note') {
        this.DetailNoteChatDialog = false
      } else if (value.name === 'edit-note') {
        this.EditNoteChatDialog = false
      } else if (value.name === 'list-note') {
        this.DetailNoteChatDialog = false
        this.NoteChatDetail = value.item
        this.NoteChatDialog = true
      } else if (value.name === 'ListForward') {
        this.ListForwardDialog = false
        this.ListForwardDetail = []
        this.statusForward = false
      }
    },
    searchContact (item) {
      this.axios.post(process.env.VUE_APP_API_MANAGE + `/searchtokenuser`, {
        tokenuser: this.data_user.tokenuser,
        tokenfriend: item.message
      }).then((response) => {
        if (response.data.status === 'success') {
          this.InforFriend = response.data['user']
          this.InforFriend.statemember = response.data.relation
          this.DetailFriendDialog = true
        }
      }).catch(err => {
        console.log(err)
      })
    },
    openDialog (item, type) {
      // console.log(item)
      // if (item.typeofmessage === 'contact') {
      //   item.tokenuser = item.message
      // }
      // console.log(type)
      if (type === 'note') {
        // console.log(item)
        item.previous = 'chat-room'
        this.NoteDetail = item
        this.DetailNoteChatDialog = true
      } else if (type === 'detailfriend') {
        this.axios.post(process.env.VUE_APP_API_MANAGE + `/searchtokenuser`, {
          tokenuser: this.data_user.tokenuser,
          tokenfriend: item.tokenuser
        }).then((response) => {
          if (response.data.status === 'success') {
            this.InforFriend = response.data['user']
            this.InforFriend.statemember = response.data.relation
            this.InforFriend.path = undefined
            this.DetailFriendDialog = true
          }
        }).catch(err => {
          console.log(err)
        })
        // this.$router.push(`/profile/friend/${item.tokenuser}`)
      } else if (type === 'contact') {
        this.menuChat = false
        this.ListContactDialog = true
        // console.log(type)
      } else if (type === 'location') {
        this.menuChat = false
        this.LocationDialog = true
        // console.log(type)
      } else if (type === 'listfriend') {
        // console.log(this.selectedForward)
        this.ListForwardDetail = this.selectedForward
        this.ListForwardDialog = true
      } else if (type === 'albums') {
        item.album_id = item.file_name
        this.DetailAlbumsDialog = item
        this.DetailAlbumsChatDialog = true;
      } else if (type === 'task') {
        this.taskid = item.task_id
        this.dialogDetailTask = true
      }
    },
    showMenu(type) {
      // console.log(type)
      // console.log(this.typeRoom)
      this.showmenu = type
      this.$router.push(`/chat/menu/${this.tokenroom}/${this.typeRoom}`)
    },
    closeCheckBrowser(value) {
      this.checkBrowserDialog = value
    },
    detailFriend(token) {
      this.$router.push(`/profile/friend/${token}`)
    },
    checkBrowser (url, item) {
      // console.log(item)
      if (_.includes(url, `${process.env.VUE_APP_QRcode}/qrcode/friend?id=`)) {
        var link = _.split(url, '?id=', 2)
        // console.log(link[1])
        // console.log(atob(link[1]))
        this.detailFriend(atob(link[1]))
      } else {
        // Get the user-agent string
        let userAgentString = navigator.userAgent;
        // Detect Chrome
        let chromeAgent = userAgentString.indexOf("Chrome") > -1;
        // Detect Internet Explorer
        let IExplorerAgent = userAgentString.indexOf("MSIE") > -1 || userAgentString.indexOf("rv:") > -1;
        // Detect Firefox
        let firefoxAgent = userAgentString.indexOf("Firefox") > -1;
        // Detect Safari
        let safariAgent = userAgentString.indexOf("Safari") > -1;
        // Discard Safari since it also matches Chrome
        let operaAgent = userAgentString.indexOf("OP") > -1;
        if (firefoxAgent === true || IExplorerAgent === true || operaAgent === true) {
          if (item.payload !== undefined && item.payload !== null) {
            if (item.payload.news_id !== undefined) {
              this.checkBrowserInfor = {
                url: url,
                payload: item.payload
              }
            } else {
              this.checkBrowserInfor = {
                url: url
              }
            }
          } else {
            this.checkBrowserInfor = {
              url: url,
              payload: ''
            }
          }
          this.checkBrowserDialog = true
        } else if (safariAgent === true && chromeAgent === true) {
          //  console.log('savelog')
          // window.open(url, '_blank')
          try {
            const data_sign = { message: url }
            window.flutter_inappwebview.callHandler('op_openwebview', data_sign);
          } catch (e) {
            this.checkBrowserInfor = {
              url: url,
              payload: ''
            }
            this.checkBrowserDialog = true
          }
          
          if (item.payload !== undefined && item.payload !== null) {
            if (item.payload.news_id !== undefined) {
              this.saveLogNews(item)
            }
          }
        } else if (safariAgent === true) {
          // this.checkBrowserInfor =
          if (item.payload !== undefined && item.payload !== null) {
            if (item.payload.news_id !== undefined) {
              this.checkBrowserInfor = {
                url: url,
                payload: item.payload
              }
            } else {
              this.checkBrowserInfor = {
                url: url
              }
            }
          } else {
            this.checkBrowserInfor = {
              url: url,
              payload: ''
            }
          }
          this.checkBrowserDialog = true
        } else {
          // console.log('savelog')
          // window.open(url, '_blank')
          this.checkBrowserInfor = {
            url: url,
            payload: ''
          }
          this.checkBrowserDialog = true
          if (item.payload !== undefined && item.payload !== null) {
            if (item.payload.news_id !== undefined) {
              this.saveLogNews(item)
            }
          }
        }
      }
    },
    btn_official_template(item, tokenuserBot, tokenmessage) {
      // console.log(item)
      if (item.sign == 'true' && item.type !== 'text') {
        // this.getSign(item.url, item, tokenuserBot)
        var body = {
          "tokenuser": this.tokenuser,
          "url": item.url
        }

        this.axios.post(process.env.VUE_APP_API_alpine + '/v1/getAccesstoken', body).then((response) => {
          var new_url = ''
          new_url = response.data.data.url
          // item.url = response.data.data.url
          if (item.type === 'link' || (item.type === 'webview' && tokenuserBot === process.env.VUE_APP_BOT_Paperless)) {
            // this.checkBrowser(new_url, item)
            try {
              const data_sign = { message: new_url }
              window.flutter_inappwebview.callHandler('op_openwebview', data_sign);
            } catch (e) {
              this.checkBrowser(new_url, item)
            }
          } else if (item.type === 'webview') {
            this.Webview_item = {
              label: item.label,
              url: new_url,
              size: item.size,
              type: item.type
            }
            this.dialogWebviewbig = true
          } else if (item.type === 'link_market') {
            // this.$swal('', 'ขออภัย ข้อความนี้ไม่รองรับการใช้งานบนเว็บไซต์', 'warning')
            this.ErrorDialogDetail = {
              title: 'Warning',
              text: this.$t('Alert.Warning.link_market')
            }
            this.ErrorDialog = true
          }
        }, (error) => {
          console.log(erorr)
        })
      } else if (item.onechat_token === 'true' && item.type !== 'text') {
        var today = new Date()
        var dd = String(today.getDate()).padStart(2, '0')
        var hour = String(today.getHours() + 1).padStart(2, '0')
        var minute = String(today.getMinutes()).padStart(2, '0')
        var seconds = String(today.getSeconds()).padStart(2, '0')
        var milsec = today.getMilliseconds()
        var mm = String(today.getMonth() + 1).padStart(2, '0')
        var yyyy = today.getFullYear()
        // เช็คเวลาช่วงเที่ยงคืน ให้บวกค่าวันไปด้วย
        if (hour === '24') {
          hour = '00'
          dd = String(today.getDate() + 1).padStart(2, '0')
          var date_of_month = new Date(yyyy, mm + 1, 0).getDate()
          // เช็ควันที่บวกว่าเป็นวันสุดท้ายของเดือน?
          if (parseInt(dd) === date_of_month) {
            // ถ้าเป็นวันสุดท้ายของเดือนในเซตวันเป็นวันที่ 1
            dd = '1'
            // เช็คเดือนว่าเป็นเดือนสุดท้ายของปี?
            if (mm === '12') {
              // ถ้าเป็นเดือนสุดท้ายในเซตเป็นเดือน 1แล้วก็บวกปีเพิ่ม
              mm = '1'
              yyyy = today.getFullYear() + 1
            } else {
              // ไม่ใช่เดือนสุดท้ายก็บวกเดือนเพิ่มมา 1 เดือน (+2 เพราะว่าเดือนมันเริ่มที่ 0 getMonth ล่่าสุดมาแล้ว คือ +1 แล้วบวกไปอีก 1 เลยเป็น +2)
              mm = String(today.getMonth() + 2).padStart(2, '0')
              // console.log(mm)
            }
          }
        }
        today = yyyy + '-' + mm + '-' + dd + 'T' + hour + ':' + minute + ':' + seconds + '.' + milsec + 'Z'
        // console.log(today)
        var expireddate = Date.parse(today)
        var body = Encode.encodeRichmenu({
          'userid': this.tokenuser,
          'expired_date': expireddate
        })
        // var url = '?onechat_token=' + body + '&' + 'expired_date=' + expireddate
        // var weburl = item.url + url
        var url = ''
        if (_.includes(item.url, ['?'])) {
          url = '&'
        } else {
          url = '?'
        }
        var weburl = item.url + url + 'onechat_token=' + body + '&' + 'expired_date=' + expireddate

        if (item.type === 'link' || (item.type === 'webview' && tokenuserBot === process.env.VUE_APP_BOT_Paperless)) {
          // this.checkBrowser(weburl, item)
          try {
            const data_sign = { message: weburl }
            window.flutter_inappwebview.callHandler('op_openwebview', data_sign);
          } catch (e) {
            this.checkBrowser(weburl, item)
          }
        } else if (item.type === 'webview') {
          this.Webview_item = {
            label: item.label,
            url: weburl,
            size: item.size,
            type: item.type
          }
          this.dialogWebviewbig = true
        } else if (item.type === 'link_market') {
          // this.$swal('', 'ขออภัย ข้อความนี้ไม่รองรับการใช้งานบนเว็บไซต์', 'warning')
          this.$swal('', this.$t('Alert.Warning.link_market'), 'warning')
        }
      } else {
        if (item.type === 'link' || (item.type === 'webview' && tokenuserBot === process.env.VUE_APP_BOT_Paperless)) {
          // this.checkBrowser(item.url, item)
          try {
            const data_sign = { message: item.url }
            window.flutter_inappwebview.callHandler('op_openwebview', data_sign);
          } catch (e) {
            this.checkBrowser(item.url, item)
          }
        } else if (item.type === 'webview') {
          this.Webview_item = item
          this.dialogWebviewbig = true
        } else if (item.type === 'text') {
          this.ans_question(item, tokenmessage, tokenuserBot)
        } else if (item.type === 'file') {
          this.ans_question(item, tokenmessage, tokenuserBot)
        } else if (item.type === 'link_market') {
          // this.$swal('', 'ขออภัย ข้อความนี้ไม่รองรับการใช้งานบนเว็บไซต์', 'warning')
          this.ErrorDialogDetail = {
            title: 'Warning',
            text: this.$t('Alert.Warning.link_market')
          }
          this.ErrorDialog = true
        }
      }
    },
    btn_img_official_template(item, tokenuserBot) {
      if (item.sign === 'true') {
        this.getSignImg(item.url, item, tokenuserBot)
      } else if (item.onechat_token === 'true') {
        var today = new Date()
        var dd = String(today.getDate()).padStart(2, '0')
        var hour = String(today.getHours() + 1).padStart(2, '0')
        var minute = String(today.getMinutes()).padStart(2, '0')
        var seconds = String(today.getSeconds()).padStart(2, '0')
        var milsec = today.getMilliseconds()
        var mm = String(today.getMonth() + 1).padStart(2, '0')
        var yyyy = today.getFullYear()
        // เช็คเวลาช่วงเที่ยงคืน ให้บวกค่าวันไปด้วย
        if (hour === '24') {
          hour = '00'
          dd = String(today.getDate() + 1).padStart(2, '0')
          var date_of_month = new Date(yyyy, mm + 1, 0).getDate()
          // เช็ควันที่บวกว่าเป็นวันสุดท้ายของเดือน?
          if (parseInt(dd) === date_of_month) {
            // ถ้าเป็นวันสุดท้ายของเดือนในเซตวันเป็นวันที่ 1
            dd = '1'
            // เช็คเดือนว่าเป็นเดือนสุดท้ายของปี?
            if (mm === '12') {
              // ถ้าเป็นเดือนสุดท้ายในเซตเป็นเดือน 1แล้วก็บวกปีเพิ่ม
              mm = '1'
              yyyy = today.getFullYear() + 1
            } else {
              // ไม่ใช่เดือนสุดท้ายก็บวกเดือนเพิ่มมา 1 เดือน (+2 เพราะว่าเดือนมันเริ่มที่ 0 getMonth ล่่าสุดมาแล้ว คือ +1 แล้วบวกไปอีก 1 เลยเป็น +2)
              mm = String(today.getMonth() + 2).padStart(2, '0')
              // console.log(mm)
            }
          }
        }
        today = yyyy + '-' + mm + '-' + dd + 'T' + hour + ':' + minute + ':' + seconds + '.' + milsec + 'Z'
        // console.log(today)
        var expireddate = Date.parse(today)
        var body = Encode.encodeRichmenu({
          'userid': this.tokenuser,
          'expired_date': expireddate
        })
        // var url = '?onechat_token=' + body + '&' + 'expired_date=' + expireddate
        // var weburl = item.url + url
        var url = ''
        if (_.includes(item.url, ['?'])) {
          url = '&'
        } else {
          url = '?'
        }
        var weburl = item.url + url + 'onechat_token=' + body + '&' + 'expired_date=' + expireddate

        if (item.type === 'link' || (item.type === 'webview' && tokenuserBot === process.env.VUE_APP_BOT_Paperless)) {
          // this.checkBrowser(weburl, item)
          try {
            const data_sign = { message: weburl }
           window.flutter_inappwebview.callHandler('op_openwebview', data_sign);
          } catch (e) {
            this.checkBrowser(weburl, item)
          }
          item.url
        } else if (item.type === 'webview') {
          this.Webview_item = {
            label: item.label,
            url: weburl,
            size: item.size,
            type: item.type
          }
          this.dialogWebviewbig = true
        } else if (item.type === 'link_market') {
          // this.$swal('', 'ขออภัย ข้อความนี้ไม่รองรับการใช้งานบนเว็บไซต์', 'warning')
          this.ErrorDialogDetail = {
            title: 'Warning',
            text: this.$t('Alert.Warning.link_market')
          }
          this.ErrorDialog = true
        }
      } else {
        if (item.type === 'link' || (item.type === 'webview' && tokenuserBot === process.env.VUE_APP_BOT_Paperless)) {
          // this.checkBrowser(item.url, item)
          try {
            const data_sign = { message: item.url }
            window.flutter_inappwebview.callHandler('op_openwebview', data_sign);
          } catch (e) {
            this.checkBrowser(item.url, item)
          }
        } else if (item.type === 'webview') {
          this.Webview_item = item
          this.dialogWebviewbig = true
        } else if (item.type === 'link_market') {
          // this.$swal('', 'ขออภัย ข้อความนี้ไม่รองรับการใช้งานบนเว็บไซต์', 'warning')
          this.ErrorDialogDetail = {
            title: 'Warning',
            text: this.$t('Alert.Warning.link_market')
          }
          this.ErrorDialog = true
        }
      }
    },
    getSign (url, item, tokenuserBot) {
      var body = {
       "tokenuser": this.tokenuser,
       "url": url
      }
      this.axios.post(process.env.VUE_APP_API_ALPINE + `/api/v1/getAccesstoken`, body).then((response) => {
        var new_url = ''
        new_url = response.data.data.url
        if (item.type === 'link' || (item.type === 'webview' && tokenuserBot === process.env.Bot_idPaperless)) {
          // this.checkBrowser(new_url, item)
          try {
            const data_sign = { message: new_url }
            window.flutter_inappwebview.callHandler('op_openwebview', data_sign);
          } catch (e) {
            this.checkBrowser(new_url, item)
          }
        } else if (item.type === 'webview') {
          this.Webview_item = {
            label: item.label,
            url: new_url,
            size: item.size,
            type: item.type
          }
          // console.log(this.official_item)
          this.dialogWebviewbig = true
        } else if (item.type === 'link_market') {
          // this.$swal('', this.$t('Alert.Warning.link_market'), 'warning')
          this.ErrorDialogDetail = {
            title: 'Warning',
            text: this.$t('Alert.Warning.link_market')
          }
          this.ErrorDialog = true
        }
      }, (error) => {
        console.log(erorr)
        this.ErrorDialogDetail = {
          title: 'Error',
          text: this.$t('Alert.Fail.default.somethingWrong')
        }
        this.ErrorDialog = true
      })
    },
    getSignImg(url, item, tokenuserBot) {
      var body = {
        "tokenuser": this.tokenuser,
        "url": url
      }
      this.axios.post(process.env.VUE_APP_API_EVENT + '/old/api/v1/getAccesstoken', body).then((response) => {
        // item.url = response.data.data.url
        var new_url = ''
        new_url = response.data.data.url
        if (item.type === 'link' || (item.type === 'webview' && tokenuserBot === process.env.VUE_APP_BOT_Paperless)) {
          // this.checkBrowser(new_url, item)
          try {
            const data_sign = { message: new_url }
            window.flutter_inappwebview.callHandler('op_openwebview', data_sign);
          } catch (e) {
            this.checkBrowser(new_url, item)
          }
        } else if (item.type === 'webview') {
          this.Webview_item = {
            label: item.label,
            url: new_url,
            size: item.size,
            type: item.type
          }
          this.dialogWebviewbig = true
        } else if (item.type === 'link_market') {
          this.ErrorDialogDetail = {
            title: 'Warning',
            text: this.$t('Alert.Warning.link_market')
          }
          this.ErrorDialog = true
        }
      }).catch(err => {
        console.log(err)
        this.ErrorDialogDetail = {
          title: 'Error',
          text: this.$t('Alert.Fail.default.somethingWrong')
        }
        this.ErrorDialog = true
      })
    },
    checkbutton(color, bng) {
      var text = {
        'text-transform': 'none',
        'width': '100%',
        'margin': '0',
        'font-size': '13px',
        'border-radius': '20px'
      }
      // [choice.color]? ('color': choice.color):('color':'black')
      if (color) {
        text['color'] = color
      } else {
        text['color'] = 'black'
      }
      if (bng) {
        text['background'] = bng
      } else {
        text['background'] = 'none'
      }
      return text
    },
    clearImage() {
      document.querySelector('#uploadpic_ocr').value = ''
      document.querySelector('#uploadpic_quickreply').value = ''
    },
    InputFocusCancel () {
      // console.log(this.sheetrichmenu)
      this.menuChat = false
      this.menuSticker = false
      this.marker = true
      this.selectSticker = true
      this.focusKey = false
      this.previewMessage = false
      if (this.sheetrichmenu) {
        if (parseInt(this.ListMenuData.type_menu) <= 7) {
          this.scrollable = {
            'height': 'calc(' + this.height100 + ' - 405px) !important'
          }
        } else {
          this.scrollable = {
            'height': 'calc(' + this.height100 + ' - 277px) !important'
          }
        }
      } else {
        if (this.sheetrichmenu) {
          if (parseInt(this.ListMenuData.type_menu) <= 7) {
            this.scrollable = {
              'height': 'calc(' + this.height100 + ' - 405px) !important'
            }
          } else {
            this.scrollable = {
              'height': 'calc(' + this.height100 + ' - 277px) !important'
            }
          }
        } else {
          this.scrollable = {
            'height': 'calc(' + this.height100 + ' - 130px) !important'
          }
        }
      }
    },
    InputFocus (evt) {
      // console.log(evt)
      var me = this
      if (evt) {
        if (evt.type === 'focus') {
          me.menuSticker = false
          me.marker = true
          // alert(JSON.parse(me.scrollable))
        } else if (evt.type === 'click') {
          me.menuSticker = true
          me.marker = false
        }
        if (evt.relatedTarget === null) {
          me.menuChat = false
          // setTimeout(function() {
          //   me.scrollable = {
          //     'height': 'calc(' + me.height100 + ' - 495px) !important'
          //   }
          //   me.focusKey = true
          // }, 1000);
        } else {
          me.menuChat = false
          // setTimeout(function() {
          //   me.scrollable = {
          //     'height': 'calc(' + me.height100 + ' - 495px) !important'
          //   }
          //   me.focusKey = true
          // }, 1000);
        }
        // console.log(this.height100)
        // console.log(me.scrollable)
        me.scrollable = {
          'height': 'calc(' + '100vh' + ' - 130px) !important'
        }
        // console.log(me.scrollable)

      }
    },
    backpage() {
      // this.$router.go(-1)
      this.$router.push('/listchat')
    },
    clearQuickreply() {
      if (this.list_quickreply.quick_reply) {
        if (this.list_quickreply.timestamp < this.listchat[this.listchat.length - 1].timestamp) {
          this.list_quickreply = []
        }
      }
    },
    getreply() {
      this.list_quickreply = []
      this.axios.post(process.env.VUE_APP_API_alpine + '/v1/get-quickreply', {
        tokenroom: this.tokenroom,
        tokenuser: this.tokenuser
      }).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success' && response.data.data != "") {
          this.list_quickreply = response.data.data
          setTimeout(this.scrollToEnd, 1)
          // console.log(this.Quickreply)
        }
      })
    },
    momentday(data) {
      return Momenttime.dayjsdatetimethai(data)
    },
    senddate() {
      if (this.typepicker === 'datepicker') {
        this.datepicker = false
        this.$swal({
          title: `<div class="CSChatThai">${this.$t('Alert.Chat.sendDatetime')}</div>`,
          html: '<br><div class="CSChatThai" style="text-align:left">' + this.momentday(this.dateselect) + '</div>',
          confirmButtonColor: '#2562af',
          confirmButtonText: `<div class="CSChatThai" style="font-size: 20px;">${this.$t('AnswerQuestion.ok')}</div>`,
          cancelButtonColor: '#1b232db3',
          cancelButtonText: `<div class="CSChatThai" style="font-size: 20px;">${this.$t('AnswerQuestion.cancel')}</div>`,
          buttonsStyling: true,
          showCloseButton: true,
          showCancelButton: true,
          reverseButtons: true
        }).then((result) => {
          if (result.value) {
            var item = {
              message: this.dateselect,
              payload: this.infodata,
              type: 'datepicker'
            }
            this.ans_quickreply(item)
          }
        })
      } else if (this.typepicker === 'datetimepicker') {
        this.datepicker = false
        this.timepicker = true
        if (this.dateselect === this.mindate) {
          this.maxtime = '24:00'
        } else if (this.dateselect === this.maxdate) {
          this.mintime = '00:00'
        } else {
          this.maxtime = '24:00'
          this.mintime = '00:00'
        }
      }
    },
    sendtime() {
      this.$swal({
        title: `<div class="CSChatThai">${this.$t('Alert.Chat.sendDatetime')}</div>`,
        html: '<br><div class="CSChatThai" style="text-align:left">' + this.momentday(this.dateselect) + ' เวลา ' + this.timeselect + '</div>',
        confirmButtonColor: '#2562af',
        confirmButtonText: `<div class="CSChatThai" style="font-size: 20px;">${this.$t('AnswerQuestion.ok')}</div>`,
        cancelButtonColor: '#1b232db3',
        cancelButtonText: `<div class="CSChatThai" style="font-size: 20px;">${this.$t('AnswerQuestion.cancel')}</div>`,
        buttonsStyling: true,
        showCloseButton: true,
        showCancelButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          var item = {
            message: this.dateselect + 'T' + this.timeselect,
            payload: this.infodata,
            type: 'datetimepicker'
          }
          this.timepicker = false
          this.ans_quickreply(item)
        }
      })
    },
    setpicker(data) {
      setTimeout(this.scrollDown, 1)
      if (data.type === 'datepicker') {
        this.typepicker = data.type
        this.datepicker = true
        this.maxdate = data.max
        this.mindate = data.min
        this.dateselect = data.initial
        this.infodata = data.payload
      } else if (data.type === 'datetimepicker') {
        this.typepicker = data.type
        this.datepicker = true
        this.maxdate = data.max.split('T')[0]
        this.mindate = data.min.split('T')[0]
        this.maxtime = data.max.split('T')[1]
        this.mintime = data.min.split('T')[1]
        this.dateselect = data.initial.split('T')[0]
        this.timeselect = data.initial.split('T')[1]
        this.infodata = data.payload
      }
      // console.log(data)
    },
    onimgSelected_quickreply(data) {
      let uploadedFiles = data.target.files
      var lengthfile = uploadedFiles.length
      this.selectFile = data.target.files[0]
      var uploadFile = new FormData()
      uploadFile.append('file', this.selectFile, this.selectFile.name)
      uploadFile.append('tokenroom', this.$route.params.tokenroom)
      uploadFile.append('tokenuser', this.tokenuser)
      uploadFile.append('type_reply', this.itemdetail_quickreply.type)
      uploadFile.append('info_data', this.itemdetail_quickreply.payload)
      this.axios.post(process.env.VUE_APP_API_alpine + '/v1/answer_quickreply', uploadFile).then((response) => {
        if (response.data.status === 'success') {
          if (_.find(this.items, function(o) {
              return o.tokenmessage === response.data.data.tokenmessage
            }) === undefined) {
            // this.socketupdate_img = response.data.data
            // response.data.data.status = 'success'
            this.listchat.push(response.data.data)
            this.clearQuickreply()
            this.listchat = _.sortBy(this.listchat, function(dateObj) {
              return new Date(dateObj.timestamp)
            })
            this.listchat = _.unionBy(this.listchat, 'tokenmessage')
            document.querySelector('#uploadfile_quickreply').value = ''
            document.querySelector('#uploadpic_quickreply').value = ''
          }
          setTimeout(this.scrollDown, 1)
        } else {
          this.$swal('Network error', response.data.message, 'error')
        }
      }).catch(error => {
        console.log(error)
        this.$swal('Network error', this.$t('Alert.Fail.default.networkError'), 'error')
      })
    },
    ans_quickreply_file(item) {
      // console.log(item)
      if (item.type == 'image') {
        document.getElementById('uploadpic_quickreply').click()
      } else {
        document.getElementById('uploadfile_quickreply').click()
      }
      this.itemdetail_quickreply = item
    },
    ans_quickreply(item) {
      // console.log(item)
      var body = {
        tokenroom: this.tokenroom,
        tokenuser: this.tokenuser,
        type_reply: item.type,
        message: item.message,
        info_data: item.payload
      }
      this.axios.post(process.env.VUE_APP_API_alpine + '/v1/answer_quickreply', body).then((response) => {
        this.clearQuickreply()
        if (item.type == 'text') {
          this.insertMessage(response.data.data, response.data.tokenmessage)
        } else if (item.type === 'link' || item.type === 'webview') {
          this.check_authen(item)
        } else if (item.type === 'location') {
          var me = this
          if (window.navigator.geolocation) {
            window.navigator.geolocation.getCurrentPosition(function(position) {
              
              const lat = position.coords.latitude;
              const lon = position.coords.longitude;

              // ใช้ Google Maps Geocoding API
              // const apiKey = "AIzaSyBUh61FWG3kr4BSAEO_NRrniSz8S5ceLic";
              // const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lon}&key=${apiKey}`;

              const apiKey = "AIzaSyBUh61FWG3kr4BSAEO_NRrniSz8S5ceLic";
              const language = me.$i18n.locale !== undefined ? me.$i18n.locale : 'th'; // ภาษาไทย
              const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lon}&language=${language}&key=${apiKey}`;
              
              fetch(url)
                .then((response) => response.json())
                .then((data) => {
                  if (data.results.length > 0) {
                    // console.log("สถานที่:", data.results[0]);
                    me.send_location(position.coords.latitude, position.coords.longitude, data.results[0].formatted_address)
                  } else {
                    console.log("ไม่พบข้อมูลสถานที่");
                    me.send_location(position.coords.latitude, position.coords.longitude, '')
                  }
                })
                .catch((error) => console.error("Error:", error));
            },
            (error) => {
              console.error("Error getting location:", error);
            },
            function(error) {
              console.log(error)
              me.ErrorDialogDetail = {
                title: 'Warning',
                text: 'Onechat needs access to use your current location, Please allow your location.'
              }
              me.ErrorDialog = true
            })
          }
        } else if (item.type === 'link_market') {
          this.$swal('', this.$t('Alert.Warning.link_market'), 'warning')
        } else if (item.type === 'ocr') {
          document.getElementById('uploadpic_ocr').click()
          this.ocr_detailItem = item
        } else if (item.type === 'ekyc') {
          this.ans_ekyc_template(item, this.list_quickreply.tokenuser)
        }
      }).catch(err => {
        console.log(err)
        this.$swal('Network error', this.$t('Alert.Fail.default.networkError'), 'error')
      })
    },
    onimgSelected_ocr(data) {
      let uploadedFiles = data.target.files
      var lengthfile = uploadedFiles.length
      // console.log(this.ocr_detailItem)
      var me = this
      var reader = new FileReader();
      reader.readAsDataURL(data.target.files[0])
      reader.onloadend = function() {
        var body = {
          "tokenroom": me.$route.params.tokenroom,
          "tokenuser": me.tokenuser,
          "base64_image": reader.result,
          "multi_select": me.ocr_detailItem.multi_select
        }
        me.dialogWebviewbig_ocr = true
        // me.Webview_item = {url: "https://chat-develop.one.th/ocr_scantext?id=Ua4KAHvPEqd2wOXF28cD9", label: ''}

        me.axios.post('https://l.one.th/onechat-ocr/api/v1/send-ocr-image', body).then((response) => {
          // console.log(response.data.data.link)
          if (response.data.message === 'success') {
            // me.dialogWebviewbig = true
            me.Webview_item_ocr = {
              url: response.data.data.link,
              label: ''
            }
            me.clearQuickreply()
          }
        }, () => {
          me.$swal('Upload image fail', this.$t('Alert.Fail.Chat.uploadPic'), 'warning')
          // this.$swal('Network error', this.$t('Alert.Fail.default.networkError'), 'error')
        })
      }
    },
    send_location(lat, long, address) {
      // console.log(lat, long, address)
      // var textaddress = ''
      // if (address === '') {
      //   textaddress = lat + ',' + long
      // } else {
      //   textaddress = address
      // }
      this.sheetrichmenu = false
      // this.InputFocusCancel()
      if (lat !== '' && long !== '') {
        this.axios.post(process.env.VUE_APP_API_alpine + '/v1/pushLocation', {
          'tokenroom': this.$route.params.tokenroom,
          'tokenuser': this.tokenuser,
          'lat': lat + '',
          'long': long + '',
          'address': address
        }).then((response) => {
          // console.log(response.data)
          if (response.data.status === 'success') {
            if (_.find(this.listchat, function(o) {
                return o.tokenmessage === response.data.data.tokenmessage
              }) === undefined) {
              response.data.data.status = 'success'
              this.listchat.push(response.data.data)
              this.clearQuickreply()
              this.listchat = _.sortBy(this.listchat, function(dateObj) {
                return new Date(dateObj.timestamp)
              })
              this.listchat = _.unionBy(this.listchat, 'tokenmessage')
              this.clearQuickreply()
            }
            setTimeout(this.scrollDown, 1)
          } else {}
        }, (error) => {
          console.log(error)
          // this.$swal('Network error', 'โปรดตรวจการเชื่อมต่ออินเตอร์เน็ต', 'error')
          this.$swal('Network error', this.$t('Alert.Fail.default.networkError'), 'error')
        })
      }
    },
    insertMessage(data, tokenmessage) {
      // console.log(data)
      if (data.tokenroom === this.tokenroom) {
        if (_.find(this.listchat, function(o) {
            return o.tokenmessage === tokenmessage
          }) === undefined) {
          if (data !== undefined) {
            this.listchat.push(data)
          }
          this.clearQuickreply()
          this.listchat = _.sortBy(this.listchat, function(dateObj) {
            return new Date(dateObj.timestamp)
          })
          this.listchat = _.unionBy(this.listchat, 'tokenmessage')
        }

        if (!this.gotoBtm || !this.gotoMsg) {
          setTimeout(this.scrollToEnd, 1)
        }
      }
    },
    ans_question(item, tokenmessage, tokenbot) {
      // console.log(item)
      if (item.payload === undefined) {
        item.payload = null
      }
      var body = {
        tokenmessage: tokenmessage,
        tokenuser: this.tokenuser,
        answer: item
      }
      this.axios.post(process.env.VUE_APP_API_ALPINE + '/answer_question', body).then((response) => {
        if (item.type === 'text') {
          this.insertMessage(response.data.data, response.data.data.tokenmessage)
        } else if (item.type === 'link' || item.type === 'webview') {
          this.check_authen(item)
        } else if (item.type === 'file') {
          this.downloadFile(item.file, item.file.split('/')[item.file.split('/').length - 1])
        } else if (item.type === 'link_market') {
          this.$swal('', this.$t('Alert.Warning.link_market'), 'warning')
        } else if (item.type === 'ekyc') {
          this.ans_ekyc_template(item, tokenbot)
        }
      }).catch(error => {
        console.log(error)
      })
    },
    check_authen(item) {
      if (item.sign === 'true') {
        var body = {
          tokenuser: this.tokenuser,
          url: item.url
        }
        this.axios.post(process.env.VUE_APP_API_alpine + '/v1/getAccesstoken', body).then((response) => {
          if (response.data.data) {
            var new_url = response.data.data.url
            this.checktypeOpenweb(new_url, item)
          } else {
            this.dialogLogin = true
          }
        }, (error) => {
          console.log(error)
        })
      } else if (item.onechat_token === 'true') {
        var expireddate = Encode.ExpiredDataOnechatToken()
        var body = Encode.encodeRichmenu({
          'userid': this.tokenuser,
          'expired_date': expireddate
        })
        var url = ''
        if (_.includes(item.url, ['?'])) {
          url = '&'
        } else {
          url = '?'
        }
        var weburl = item.url + url + 'onechat_token=' + body + '&' + 'expired_date=' + expireddate
        this.checktypeOpenweb(weburl, item)

      } else {
        this.checktypeOpenweb(item.url, item)
      }
    },
    checktypeOpenweb(link, item) {
      // console.log('checktypeOpenweb: ', item)
      // console.log('link: ', link)
      if (item.type === 'link') {
        // window.open(link, '_blank')
        try {
          const data_sign = { message: link }
          window.flutter_inappwebview.callHandler('op_openwebview', data_sign);
        } catch (e) {
          this.checkBrowser(link, item)
        }
      } else if (item.type === 'webview') {
        this.Webview_item = {
          label: item.label,
          url: link,
          size: item.size,
          type: item.type
        }
        this.dialogWebviewbig = true
      }

    },
    ans_ekyc_template(item, tokenbot) {
      this.axios.post(process.env.VUE_APP_API_message + '/api/v1/get_shared_token', {
        user_id: this.data_user.one_id
      }).then((response) => {
        if (response.data.status === 'success') {
          var url = `${process.env.VUE_APP_API_Oneid_EKYCbysharetoken}${response.data.data.shared_token}&bot_id=${tokenbot}`
          // if (item.payload !== undefined) {
          //   this.Webview_item = {
          //     label: item.label,
          //     url: url,
          //     size: 'full',
          //     type: 'ekyc',
          //     payload: item.payload
          //   }
          // } else {
          //   this.Webview_item = {
          //     label: item.label,
          //     url: url,
          //     size: 'full',
          //     type: 'ekyc',
          //     payload: ''
          //   }
          // }
          // console.log('url: ', url);
          // this.dialogWebviewbig = true
          try {
            const data = { message: url }
            const result = window.flutter_inappwebview.callHandler('op_openwebview', data);
            // Handle the successful result here
          } catch (error) {
            // Handle the error returned from the function
            console.error('Error: ', error);
            if (item.payload !== undefined) {
              this.Webview_item = {
                label: item.label,
                url: url,
                size: 'full',
                type: 'ekyc',
                payload: item.payload
              }
            } else {
              this.Webview_item = {
                label: item.label,
                url: url,
                size: 'full',
                type: 'ekyc',
                payload: ''
              }
            }
            // console.log('url: ', url);
            // this.dialogWebviewbig = true
            this.checkBrowser(url, this.Webview_item)
          }
        }
      }).catch(error => {
        this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'error')
      })
    },
    clickReadmore(item) {
      this.detailReadmore = item
      this.dialogReadmore = true
    },
    closeReadmoreDialog(value) {
      this.dialogReadmore = value
    },
    closeWebview(value) {
      this.Webview_item = {}
      this.Webview_item_ocr = {}
      this.dialogWebviewbig = value
      this.dialogWebviewbig_ocr = value
    },
    getroom() {
      const body = {
        tokenuser: this.tokenuser,
        tokenroom: this.tokenroom
      }
      this.axios.post(process.env.VUE_APP_API_MANAGE + '/getroom', body).then((response) => {
        if (response.status === 200) {
          var me = this
          this.detialroom = response.data
          this.typeRoom = response.data.type
          this.statemember = response.data.statemember
          this.listfriend = _.filter(response.data.data_room, function(o) { return o.statemember === 'active' && o.type !== 'bot' })
          if (this.detialroom.type == 'user') {
            this.pictureRoom = this.detialroom.data_room[0].profilepicture
            if (this.detialroom.data_room[0].type == 'bot') {
              // this.getRichmenu(this.detialroom.data_room[0].tokenuser)
              if(this.statemember === 'active') {
								this.getRichmenu(this.detialroom.data_room[0].tokenuser)
							}
            }
            if (!this.pictureRoom && this.detialroom.data_room[0].type == 'bot') {
              this.pictureRoom = `${this.publicPath}/assets/img/default_profile/bot-white.png`
            } else if (!this.pictureRoom && this.detialroom.data_room[0].type == 'user') {
              this.pictureRoom = `${this.publicPath}/assets/img/default_profile/man-white.png`
            }
            this.nameRoom = this.detialroom.data_room[0].name
          } else {
            this.pictureRoom = this.detialroom.picture
            if (!this.pictureRoom) {
              this.pictureRoom = `${this.publicPath}/assets/img/default_profile/group-white.png`
            }
            this.nameRoom = this.detialroom.group_name
             // + "  (" + this.detialroom.count_member + ")"
          }
        }
      })
    },
    getRichmenu(tokenbot) {
      // console.log('get richmenu')
      // this.scrollable = { 'height': 'calc(' + this.height100 + ' - 130px) !important' }
      // console.log(this.scrollable)
      // this.RichmenuState = false
      // this.sheetrichmenu = false
      // this.menuChat = false
      // this.ListMenuData = ''
      this.axios.post(process.env.VUE_APP_API_GO + `/v1/get-richmenu-by-botid`, {
        bot_id: tokenbot
      }).then((response) => {
        if (response.data.status === 'success') {
          this.ListMenuData = response.data.data
          this.bot_id_richmenu = response.data.data.bot_id
          if (this.ListMenuData.default_behavior === '1') {
            this.RichmenuState = true
            this.sheetrichmenu = true
            this.menuChat = false
          } else {
            this.RichmenuState = false
            this.sheetrichmenu = false
            this.menuChat = false
          }
          // console.log(this.ListMenuData)
        }
      }).catch(err => {
        console.log(err)
        this.ErrorDialogDetail = {
          title: 'Error',
          text: this.$t('Alert.Fail.default.somethingWrong')
        }
        this.ErrorDialog = true
      })
    },
    sendFileAndImage(data) {
      this.menuChat = false
      this.menuChatBottom = false
      // this.InputFocusCancel()
      let uploadedFiles = data.target.files
      var lengthfile = uploadedFiles.length
      var sizefile = []
      for (var i = 0; i < lengthfile; i++) {
        sizefile[i] = uploadedFiles[i].size
      }
      if (_.sum(sizefile) / 1024 / 1024 > 100) {
        this.$swal({
          title: 'ขนาดไฟล์ใหญ่เกินไป',
          type: 'warning'
        })
      } else {
        for (let i = 0; i < lengthfile; i++) {
          if (uploadedFiles[i].type === 'image/jpeg' || uploadedFiles[i].type === 'image/png' || uploadedFiles[i].type === 'image/jpg') {
            this.sendFile(uploadedFiles[i], process.env.VUE_APP_API_message + '/push_image')
          } else if (this.extension(uploadedFiles[i].name) === 'media') {
            this.sendFile(uploadedFiles[i], process.env.VUE_APP_API_media + '/v1/send-video')
          } else {
            this.sendFile(uploadedFiles[i], process.env.VUE_APP_API_message + '/push_file')
          }
        }
      }
    },
    sendFile(uploadedFiles, path) {
      var uploadFile = new FormData()
      uploadFile.append('file', uploadedFiles, uploadedFiles.name)
      uploadFile.append('tokenroom', this.tokenroom)
      uploadFile.append('tokenuser', this.tokenuser)
      uploadFile.append('type', this.typeuser)
      this.axios.post(path, uploadFile).then((response) => {
        if (response.data.status === 'success') {
          response.data.data.status = 'success'
          this.insertMessage(response.data.data, response.data.data.tokenmessage)
          document.querySelector('#uploadfileChat').value = ''
          document.querySelector('#uploadpic').value = ''
        } else {
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        }
      }, (error) => {
        console.log(error)
        this.ErrorDialogDetail = {
          title: 'Error',
          text: this.$t('Alert.Fail.default.somethingWrong')
        }
        this.ErrorDialog = true
      })
    },
    sendReply (msg) {
      // console.log(msg)
      var body = {
        mention_message: msg,
        tokenroom: this.tokenroom,
        tokenuser: this.tokenuser,
        tokenmessage: this.reply_data.tokenmessage
      }
      if (!this.isBlank(msg) && !this.isEmpty(msg)) {
        this.axios.post(process.env.VUE_APP_API_message + `/mention_message`, body, {
        }).then((response) => {
          if (response.data.status === 'success') {
            this.reply_status = false
            // console.log(response.data.data)
            this.reply_data = ''
            this.msgSend = ''
            this.insertMessage(response.data.data, response.data.data.tokenmessage)
          } else {
            this.ErrorDialogDetail = {
              title: 'Error',
              text: this.$t('Alert.Fail.default.somethingWrong')
            }
            this.ErrorDialog = true
          }
        }).catch(err => {
          console.log(err)
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        })
      }
    },
    sendMessage(data) {
      //กดส่งแป้นพิมพ์ปิด
      // console.log(this.sheetrichmenu)
      this.sheetrichmenu = false
      // this.InputFocusCancel()
      let replaced = data.replace(/(?:\r\n|\r|\n)/g, '<br>')
      if (this.reply_status) {
      this.sendReply(data)
      } else {
        try {
          if (event.keyCode === 13 || event.which === 1) {
            if (event.shiftKey && replaced !== '') {
              this.msgSend.replace(this.msgSend, '<br>')
            } else {
              if (!this.isBlank(data) && !this.isEmpty(data)) {
                this.axios.post(process.env.VUE_APP_API_alpine + '/v1/pushMessage', {
                  tokenroom: this.tokenroom,
                  tokenuser: this.tokenuser,
                  type: this.typeuser,
                  message: data
                }).then((response) => {
                  var messageSendChat = response.data.data
                  if (response.data.status === 'success') {
                    this.msgSend = ''
                    messageSendChat['status'] = 'success'
                    this.insertMessage(messageSendChat, messageSendChat.tokenmessage)
                  } else {
                    this.listchat.push({
                      tokenuser: this.tokenuser,
                      message: data,
                      tokenroom: this.tokenroom,
                      typeofmessage: 'message',
                      timestamp: Momenttime.dayjstimestamp(),
                      tokenmessage: btoa(Momenttime.dayjstimestamp()),
                      path_pic: this.profileSelf,
                      nickname: '',
                      file_name: '',
                      status: 'no'
                    })
                    this.msgSend = ''
                    this.scrollToEnd()
                  }
                }, (error) => {
                  this.listchat.push({
                    tokenuser: this.tokenuser,
                    message: data,
                    tokenroom: this.tokenroom,
                    typeofmessage: 'message',
                    timestamp: Momenttime.dayjstimestamp(),
                    tokenmessage: btoa(Momenttime.dayjstimestamp()),
                    path_pic: this.profileSelf,
                    nickname: '',
                    file_name: '',
                    status: 'no'
                  })
                  this.msgSend = ''
                  this.scrollToEnd()
                })
              }
            }
          }
        } catch (e) {
          console.log(e)
        }
      }
    },
    isBlank(str) {
      return (!str || /^\s*$/.test(str))
    },
    isEmpty(str) {
      return (!str || str.length === 0)
    },
    scrollToEnd() {
      this.$nextTick(() => {
        var container = this.$refs.chatContainer
        container.scrollTop = container.scrollHeight
      })
    },
    onScroll() {
      let scrollValue = this.$refs.chatContainer
      // let scrollValue = this.$refs.chatContainer
			// console.log("scrollValue =>", scrollValue);
			const distanceToBottom = scrollValue.scrollHeight - (scrollValue.scrollTop + scrollValue.clientHeight);
			// console.log('distanceToBottom: ', distanceToBottom > 70);
			if (distanceToBottom > 70) {
				this.gotoBtm = true
				if (this.socketmessage !== null && this.socketmessage.tokenroom === this.tokenroom) {
					this.gotoMsg = true
				}
			} else {
				this.gotoBtm = false
				this.gotoMsg = false
				this.socketmessage = null
			}
      if (scrollValue.scrollTop == 0 && this.isLoading == false) {
        this.getmessageHistory(this.listchat[0]['timestamp'])
      }
      this.setHeightTyping(this.rows)
    },
    getmessageHistory(time) {
      this.temp = this.selectedForward
      this.selectedForward = []
      this.axios.post(process.env.VUE_APP_API_alpine + '/v1/getdictmessage', {
        tokenroom: this.tokenroom,
        tokenuser: this.tokenuser,
        time_in: time
      }).then((response) => {
        if (response.data['status'] === 'success') {
          var message = response.data.data
          this.listchat.unshift.apply(this.listchat, response.data['data'].reverse())
          if (message.length === 20) {
            this.statusload = true
          } else if (message.length < 20) {
            this.statusload = false
          }
          this.selectedForward = this.temp
          if (time === '') {
            setTimeout(this.scrollToEnd, 1)
          } else {
            this.$nextTick(() => {
              this.gotoMessage(message[message.length - 1].tokenmessage)
            })
          }
          // console.log(this.listchat)
        } else {
          if (response.data.message === 'not member.') {
            this.$router.push('/chat/not_permission')
          }
        }
      })
    },
    gotoMessage(token) {
      if (token) {
        var myElement = document.getElementById(token)
        if (myElement) {
          myElement.scrollIntoView({
            duration: true,
            behavior: 'smooth',
            block: 'end',
            queue: false,
            specialEasing: null
          })
          window.location.hash = token
        }
      }
    },
    openInput(id) {
      document.querySelector(id).click()
    },
    closemodal() {
      var modal = document.getElementById('myModalImage')
      modal.style.display = 'none'
      var modalpdf = document.getElementById('myModalpdf')
      modalpdf.style.display = 'none'
      var modalvideo = document.getElementById('myModalVideo')
      modalvideo.style.display = 'none'
      this.thumbnail_video = ''
      this.sources_video = []
      this.videoOptions = {
        autoplay: false,
        controls: true,
        muted: true
      }
    },
    downloadFile(file, name) {
      // console.log(file)
      // console.log(name)
      // alert(name)
      // alert(file)

      // try {
      //   const data = { message: file }
      //   window.flutter_inappwebview.callHandler('op_openwebview', data);
      // } catch (e) {
      //   this.axios.get(file, {
      //     responseType: 'blob'
      //   }).then((response) => {
      //     const url = window.URL.createObjectURL(new Blob([response.data]))
      //     const link = document.createElement('a')
      //     link.href = url
      //     link.setAttribute('download', name)
      //     document.body.appendChild(link)
      //     link.click()
      //   })
      // }

      this.axios.get(file, {
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', name)
        document.body.appendChild(link)
        link.click()
      })
    },
    openFilePDF(file) {
      this.urlpdf = file.message
      this.filenamepdf = file.file_name
      var modal = document.getElementById('myModalpdf')
      modal.style.display = 'block'
    },
    zoom(item) {
      // console.log(item)
      if (item.typeofmessage == 'image') {
        var modal = document.getElementById('myModalImage')
        var modalImg = document.getElementById('img01')
        modal.style.display = 'block'
        modalImg.src = item.message
      } else {
        var modalVideo = document.getElementById('myModalVideo')
        // var modalVideo = document.getElementById('video01')
        modalVideo.style.display = 'block'
        this.thumbnail_video = item.thumbnail
        this.sources_video = [item.message]
        this.videoOptions = {
          autoplay: true,
          controls: true,
          muted: false
        }
      }

    },
    extension(path) {
      var extension = path.split('.')[path.split('.').length - 1].toLowerCase()
      var archive = ['zip', 'jar', 'rar', 'tar', 'a', 'ar', 'shar', '7z', 'arj', 'deb', 'pkg', 'gz', 'rpm', 'z']
      var pdf = ['pdf']
      var spreadsheet = ['xls', 'xlsx', 'xlt', 'xlsm', 'xlm', 'xlsm']
      var presentation = ['ppt', 'pps', 'pot', 'pptx']
      var word = ['doc', 'docx', 'dot', 'dotx', 'dotm', 'docm', 'docb', 'wbk']
      var execution = ['apk', 'bat', 'bin', 'pl', 'cgi', 'com', 'exe', 'gadget', 'jar', 'py', 'vue', 'wsf', 'css', 'htm', 'html', 'js', 'php', 'xhtml', 'c', 'class', 'cpp', 'vb', 'h', 'sh', 'swift']
      var image = ['ai', 'gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'ps', 'psd', 'svg', 'tif', 'tiff']
      var media = ['mpg', 'mpeg', 'avi', 'wmv', 'mov', 'rm', 'ram', 'swf', 'flv', 'ogg', 'webm', 'mp4']
      var audio = ['mp3', 'wma', 'aac', 'ogg', 'm4a', 'wav', 'cda', 'flac', 'aiff', 'caf']
      if (pdf.includes(extension)) {
        return 'fas fa-file-alt'
      } else if (archive.includes(extension)) {
        return 'fas fa-file-archive'
      } else if (spreadsheet.includes(extension)) {
        return 'fas fa-file-excel'
      } else if (presentation.includes(extension)) {
        return 'fas fa-file-powerpoint'
      } else if (word.includes(extension)) {
        return 'fas fa-file-word'
      } else if (execution.includes(extension)) {
        return 'fas fa-file-code'
      } else if (image.includes(extension)) {
        return 'fas fa-file-image'
      } else if (media.includes(extension)) {
        return 'media'
      } else if (audio.includes(extension)) {
        return 'audio'
      } else {
        return 'fas fa-file-alt'
      }
    },
    timeMoment(data) {
      // var moment = require('moment')
      // return (moment(data).tz('Asia/Bangkok').lang('th').format('LT'))
      return Momenttime.dayjstimethai(data)
    },
    dateMoment(data) {
      // return Momenttime.dayjsdatethai(data)
      if (this.$i18n.locale == 'th') {
        return Momenttime.dayjsdatethai(data)
      } else if (this.$i18n.locale == 'cn') {
        return Momenttime.dayjsdatecn(data)
      } else {
        return Momenttime.dayjsdateen(data)
      }
    },
    convert (msg, item) {
      // console.log('msg: ', msg);
      // console.log('item.tokenuser:', item.tokenuser)
      // console.log('this.tokenuser: ', this.tokenuser);
      // return msg
      // if (msg !== null && msg !== '') {
      //   var linkifyStr = require('linkifyjs/string')
      //   var str = msg
      //   var processedContent = linkifyStr(str, {
      //     target: {
      //       url: '_blank'
      //     }
      //   })
      //   return processedContent
      // }

      var linkifyStr = require('linkifyjs/string')
      var str = msg
      var processedContent = linkifyStr(str, { target: { url: '_blank' } })
      var regex = /\s|<tax>+[\u0E00-\u0E7Fa-zA-Z'|/^\S+@\S+\.\S+$/]+<\/tax>/g
      var color = ''
      if (item.tokenuser == this.tokenuser) {
        color = '#06bee1'
      } else {
        color = '#1976d2'
      }
      // console.log(style)
      if (msg.match(regex)) {
        for (var i = 0; i < msg.match(regex).length; i++) {
          processedContent = processedContent.replace('&lt;tax&gt;', `<b style="color: ${color};">@`)
          processedContent = processedContent.replace('&lt;/tax&gt;', '</b>')
          processedContent = processedContent.replace('\t', '\u00a0\u00a0\u00a0\u00a0\u00a0')
        }
      }
      return processedContent
    },
    convertURL(msg) {
      var urlRegex = /\bhttps?:\/\/\S+/gi;
      var linkmsg = msg.match(urlRegex)
      if (linkmsg !== null) {
        if (linkmsg.length !== 0) {
          linkmsg.length = 1
          return linkmsg
        }
        return ''
      } else {
        return ''
      }
    },
  }
}
</script>
<style lang="css" scoped>

.text-overflow-new-msg {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    max-width: 20vw;
}
.typer-backmsg {
	width: 100%;
	z-index: 0;
	position: absolute;
}

.typer-backmsg-inactive {
	width: 100%;
	z-index: 0;
	height: 30px;
  position: relative;
  bottom: 20px;
}
>>>.message.own a {
  color: #06bee1 !important;
}
>>>.message a {
  color: #1976d2 !important;
}
.bg-list-swipe-unpin {
  background-color: #f44336 !important;
  height: 60px !important;
  width: 110px !important;
  color: white;
  font-weight: bold;
  font-size: 16px;
  justify-content: center;
  display: flex;
  align-items: center;
}
.bg-list-swipe-pin {
  background-color: #929292 !important;
  height: 60px !important;
  width: 110px !important;
  color: white;
  font-weight: bold;
  font-size: 16px;
  justify-content: center;
  display: flex;
  align-items: center;
}
.p-announce {
  cursor: pointer !important;
  padding-left: 15px !important;
  padding-right: 15px !important;
  margin-bottom: 0px !important;
}
.p-announce:hover {
  color: #1b232c !important;
}
.div-announce {
  position: fixed;
  right: 0px;
  z-index: 1;
  margin-right: 10px;
  top: 60px;
}
.btn-announce {
  background-color: #2463af !important;
}
/* >>>.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none !important;
} */
.fz-55 {
  font-size: 55px !important;
}
>>>.player__controls--progress {
  flex: 1 !important;
  margin: 0 8px !important;
  z-index: 0 !important;
}
>>>.aplayer .player__controls--durration {
  color: rgb(0 0 0) !important;
}
>>>.video-js {
  display: block;
  vertical-align: top;
  box-sizing: border-box;
  color: #fff;
  background-color: #000;
  position: relative;
  padding: 0;
  font-size: 10px;
  line-height: 1;
  font-weight: 400;
  font-style: normal;
  font-family: Arial,Helvetica,sans-serif;
  word-break: initial;
  /* height: 100% !important; */
  width: 100% !important;
}
.fz-18 {
  font-size: 18px !important;
}
.fz-60 {
  font-size: 60px !important;
}
.btnCancel {
  background-color: var(--Chat-ChatboxColorOwner) !important;
  color: var(--Chat-TypingboxBackground) !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 18px !important;
  border-radius: 10px;
}
.btnConfirm {
  color: var(--Chat-ChatboxColorOwner) !important;
  background-color: var(--Chat-TypingboxBackground) !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 18px !important;
  border-radius: 10px;
}
.fz-25 {
  font-size: 25px !important;
}
.text-overflow-contact {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 35vw;
  text-align: start;
}
.fz-35 {
  font-size: 35px !important;
}
.color-white {
  color: white !important;
}
.previewMessage {
  background: #1b232dde !important;
  margin: 0 !important;
  position: absolute;
  width: 100% !important;
  height: 75px !important;
  padding: 5px !important;
  z-index: 1 !important;
  top: calc(100vh - 149px) !important;
}
.previewMessage-Active {
  background: #1b232dde !important;
  margin: 0 !important;
  /* position: absolute; */
  width: 100% !important;
  height: 75px !important;
  padding: 5px !important;
  z-index: 1 !important;
  bottom: calc(100vh - 329px) !important;
}
.emojis {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.emojis:after {
  content: "";
  flex: auto;
}
.emojis span {
  padding: 0.2rem !important;
  cursor: pointer !important;
  border-radius: 5px !important;
  font-size: 30px !important;
}
.emojis span:hover {
  background: #ececec;
  cursor: pointer;
}
>>>.v-sheet.v-card:not(.v-sheet--outlined) {
  /* box-shadow: none !important; */
}
/* >>>.v-input__icon--append .v-icon {
  color: purple !important;
} */
/* append-outer-icon */
/* >>>.v-icon notranslate mdi mdi-send theme--light::after {
  color: white !important;
} */
/* >>>.v-icon notranslate v-icon--link fa fa-solid fa-face-grin theme--light::after {
  color: #2463af !important;
}
>>>.v-icon notranslate v-icon--link fa fa-solid fa-face-grin theme--light::before {
  color: grey !important;
} */
.text-transform {
  text-transform: none;
}
.message.own .wrap-file {
  font-size: 12px;
  text-align: left;
  border-left-style: solid;
  border-left-color: var(--Chat-ChatboxColorOwner) !important;
  border-left-width: thin;
  padding-left: 5px;
  /* margin-bottom: 10px !important; */
}
.chat-container .wrap-file {
  font-size: 12px;
  text-align: left;
  border-left-style: solid;
  border-left-color: var(--Chat-ChatboxColorOther) !important;
  border-left-width: thin;
  padding-left: 5px;
  /* margin-bottom: 10px !important; */
}

.vue-pdf-embed > div {
  margin-bottom: 8px;
  box-shadow: 0 2px 8px 4px rgba(0, 0, 0, 0.1);
}
.app-header {
  padding: 16px;
  box-shadow: 0 2px 8px 4px rgba(0, 0, 0, 0.1);
  background-color: #555;
  color: #ddd;
}

.app-content {
  padding: 24px 16px;
}

.right {
  float: right;
}

.message.own .border_website {
  border-left-style: solid;
  border-left-color: var(--Chat-ChatboxColorOwner) !important;
  border-left-width: thick;
  padding: 15px;
  margin-bottom: 10px;
  margin-left: 8px;
}
.message.own .img_website {
  height: 50px;
  width: 50px;
  margin: auto;
}
.message.own .centerimg_website {
  justify-content: center;
  display: flex;
  margin-bottom: 10px;
}
.message.own .description_website {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--Chat-ChatboxColorOwner) !important;
}
.message.own .title_website {
  margin: 0 !important;
  font-weight: 600;
  color: var(--Chat-ChatboxColorOwner) !important;
}

.message.own .contentfile .color-divider {
  border-color: var(--Chat-ChatboxColorOwner) !important;
}

.chat-container .border_website {
  border-left-style: solid;
  border-left-color: var(--Chat-ChatboxColorNotSupportOther) !important;
  border-left-width: thick;
  padding: 15px;
  margin-bottom: 10px;
  margin-left: 8px;
}
.chat-container .img_website {
  height: 50px;
  width: 50px;
  margin: auto;
}
.chat-container .centerimg_website {
  justify-content: center;
  display: flex;
  margin-bottom: 10px;
}
.chat-container .description_website {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--Chat-ChatboxColorNotSupportOther) !important;
}
.chat-container .title_website {
  margin: 0 !important;
  font-weight: 600;
  color: var(--Chat-ChatboxColorNotSupportOther) !important;
}

.fz-16 {
  font-size: 16px !important;
}
.fz-20 {
  font-size: 20px !important;
}
.fz-30 {
  font-size: 30px !important;
}
.icon-color {
  color: var(--Chat-Icon-Active) !important;
}
.text-overflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 60vw;
}
.text-overflow-group {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 50vw;
}
.scrolling-quickreply {
    height: 42px;
    padding: 0px;
    background: var(--Chat-Background) !important;
    width: 100vw;
    display: flex;
    overflow-x: auto;
    overflow-y: hidden;
}

.scrolling-quickreply::-webkit-scrollbar-thumb {
    background: #888 !important;
    border-radius: 10px;
    background-clip: padding-box;
}

.scrolling-quickreply::-webkit-scrollbar {
    height: 6px !important;
}

.btn-quickreply {
    border-radius: 32px;
    border: var(--Chat-QuickReplyButtonBorder) 1px solid !important;
    background: var(--Chat-QuickReplyButtonBackground) !important;
    margin: 0px 3px;
    box-shadow: none !important;
    color: var(--Chat-QuickReplyButtonColor) !important;
    text-transform: none !important;
}

.chat-container .cardTemplate {
    border-radius: 10px;
    width: 200px;
    margin-right: 10px;
}
.chat-container .titletask {
	color: rgb(0, 0, 0);
	font-size: 18px;
}
.message.own .titletask {
	color: #ffffff;
	font-size: 18px;
}
.templateCard {
    height: 100%;
    border-radius: 6px;
    max-width: 350px;
    display: inline;
    margin-right: 5px;
    padding: 10px;
    box-shadow: 0px 0px 0px -2px rgb(0 0 0 / 20%), 0px 0px 0px 0px rgb(0 0 0 / 14%), 0px 0px 5px 0px rgb(0 0 0 / 12%);
}
.templateCardOff {
    height: 100%;
    border-radius: 6px;
    max-width: 218px;
    display: inline;
    margin-right: 5px;
    padding: 10px;
    box-shadow: 0px 0px 0px -2px rgb(0 0 0 / 20%), 0px 0px 0px 0px rgb(0 0 0 / 14%), 0px 0px 5px 0px rgb(0 0 0 / 12%);
}
.templateImage {
    border-radius: 6px;
    max-height: 150px;
    max-width: 340px;
    cursor: pointer;
    margin-bottom: 5px;
}

.templateTitle {
    color: var(--Chat-HeaderBackground) !important;
    font-weight: 900;
    font-size: 15px;
    text-align: left;
}

.templateDetail {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    color: black !important;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 13px !important;
    margin-bottom: 0px !important;
    text-align: left;
}

.templateButton {
    text-transform: none;
    width: 100%;
    margin: 0;
    font-size: 13px;
    /* background: none !important;
    box-shadow: none !important; */
    color: var(--Chat-HeaderBackground) !important;
    background: var(--Chat-HeaderColor) !important;
    text-align: center;
}

/* .templateButton:hover {
    background: var(--Chat-HeaderBackground) !important;
    color: var(--Chat-HeaderColor) !important;
} */

.choice_template {
    cursor: pointer;
    white-space: pre-wrap;
}

.choice_template:hover {
    cursor: pointer;
    text-decoration: underline;
    color: var(--Chat-HeaderBackground) !important;
}

.alligator-turtle {
    object-fit: cover;
    object-position: 50% 0;
}

.toolbar-header-user {
    height: 64px;
    box-shadow: none !important;
    background: var(--Chat-HeaderBackground) !important;
}

.pictureRoomChat {
    border-radius: var(--Chat-HeaderPictureBorderRadius) !important;
}

.HeaderName {
    color: var(--Chat-HeaderColor) !important;
    margin-left: 10px;
    font-size: 22px;
    font-weight: 600;
}

.imgProfilechat {
    height: 40px;
    vertical-align: middle;
}

.systemDateNonMGT {
    padding: 3px;
    border-radius: 20px;
    background: #e8e8e875 !important;
    font-size: 12px;
    color: #808080b8;
    width: max-content;
    display: flex;
    justify-content: center;
    text-align: center !important;
    margin: auto;
    margin-bottom: 5px;
}

.systemDate {
    padding: 3px;
    border-radius: 20px;
    background: #e8e8e875 !important;
    font-size: 12px;
    color: #808080b8;
    width: max-content;
    display: flex;
    justify-content: center;
    text-align: center !important;
    margin: auto;
    margin-top: 30px;
    margin-bottom: 5px;
}

.chat-container {
    box-sizing: border-box;
    height: calc(100vh - 240px) !important;
    overflow-y: auto;
    overflow-x: hidden;
    width: 100%;
    padding: 10px 10px;
    background-color: var(--Chat-Background) !important;
}

.chat-container::-webkit-scrollbar-thumb {
    background: #888 !important;
    border-radius: 10px;
    background-clip: padding-box !important;
}

.chat-container::-webkit-scrollbar {
    width: 6px;
}

.message.own .checkbox-content {
  display: inline-block !important;
  float: left !important;
}
.chat-container .checkbox-content {
  display: inline-block !important;
  /* float: left !important; */
}
.message {
    /* margin-bottom: 3px; */
    margin-bottom: 10px;
}

.message.own {
    text-align: right;
    margin-left: 0px !important;
    margin-left: 0px !important;
    display: flow-root;
}

.message.own .content {
    color: var(--Chat-ChatboxColorOwner) !important;
    background-color: var(--Chat-ChatboxBackgroundOwner) !important;
    border: var(--Chat-ChatboxBorderOwner) !important;
    text-align: left;
    margin-left: 0px !important;
}

.message.own .contentnot_support {
    color: var(--Chat-ChatboxColorNotSupportOwner) !important;
    background-color: var(--Chat-ChatboxBackgroundOwner) !important;
    border: var(--Chat-ChatboxBorderOwner) !important;
    text-align: left;
    margin-left: 0px !important;
}

.message.own .contentNote {
    color: var(--Chat-ChatboxColorOwner) !important;
    background-color: var(--Chat-ChatboxBackgroundOwner) !important;
    width: 60vw;
    margin-left: 0px !important;
    margin-top: 5px;
    margin-bottom: 5px;
    text-align: start;
}

.message.own .contentlocation {
  color: var(--Chat-ChatboxColorOwner) !important;
  background-color: var(--Chat-ChatboxBackgroundOwner) !important;
  border: var(--Chat-ChatboxBorderOwner) !important;
  text-align: left;
  margin-left: 0px !important;
  max-width: 60vw;
  min-width: 40vw;
}

.message.own .contentfile {
    color: var(--Chat-ChatboxColorOwner) !important;
    background-color: var(--Chat-ChatboxBackgroundOwner) !important;
    border: var(--Chat-ChatboxBorderOwner) !important;
    margin-left: 0px !important;
    max-width: 60vw;
    min-width: 60vw;
}

.message.own .contentcontact {
    color: var(--Chat-ChatboxColorOwner) !important;
    background-color: var(--Chat-ChatboxBackgroundOwner) !important;
    border: var(--Chat-ChatboxBorderOwner) !important;
    margin-left: 0px !important;
    max-width: 60vw;
    min-width: 60vw;
}

.message.own .contentvideo {
    margin-left: 0px !important;
}

.message.own .contentimage {
    margin-left: 0px !important;
}

.message.own .contenttemplate {
    margin-left: 0px !important;
}

.message.own .contentvideo {
    margin-left: 0px !important;
}

.message.own .contentfile .iconFile {
    color: var(--Chat-ChatboxColorOwner) !important;
    border: var(--Chat-ChatboxBorderOwner) !important;
    margin-left: 0px !important;
    font-size: 60px;
    margin-right: 10px;
}

.message.own .contentcontact .iconContact {
    color: var(--Chat-ChatboxColorOwner) !important;
    border: var(--Chat-ChatboxBorderOwner) !important;
    margin-left: 0px !important;
    font-size: 16px;
    margin-right: 10px;
}


.chat-container .username {
    font-size: 14px;
    font-weight: bold;
    color: #1569bb;
    padding: 10px;
}


.chat-container .content {
    padding: 10px;
    color: var(--Chat-ChatboxColorOther) !important;
    background-color: var(--Chat-ChatboxBackgroundOther) !important;
    border-radius: var(--Chat-ChatboxBorderRadiusOther);
    border: var(--Chat-ChatboxBorderOther) !important;
    display: inline-block;
    box-shadow: none;
    max-width: 60vw;
    word-wrap: break-word;
    font-size: 14px;
    margin-left: 25px;
}

.chat-container .contentnot_support {
    padding: 10px;
    background-color: var(--Chat-ChatboxBackgroundOther) !important;
    border-radius: var(--Chat-ChatboxBorderRadiusOther);
    border: var(--Chat-ChatboxBorderOther) !important;
    color: var(--Chat-ChatboxColorNotSupportOther) !important;
    display: inline-block;
    box-shadow: none;
    max-width: 60vw;
    word-wrap: break-word;
    font-size: 14px;
    margin-left: 35px;
    color: gray !important;
}

.chat-container .contentNote {
    background-color: var(--Chat-ChatboxBackgroundOther) !important;
    border-radius: 10px;
    display: inline-block;
    box-shadow: none;
    font-size: 14px;
    margin-left: 35px;
    margin-top: 5px;
    margin-bottom: 5px;
    width: 60vw;
}

.chat-container .contentlocation {
  padding: 10px;
  color: var(--Chat-ChatboxColorOther) !important;
  background-color: var(--Chat-ChatboxBackgroundOther) !important;
  border-radius: var(--Chat-ChatboxBorderRadiusOther);
  border: var(--Chat-ChatboxBorderOther) !important;
  display: inline-block;
  box-shadow: none;
  max-width: 60vw;
  word-wrap: break-word;
  font-size: 14px;
  margin-left: 35px;
  max-width: 60vw;
  min-width: 40vw;
}

.chat-container .contentvideo {
    border-radius: 10px;
    display: inline-block;
    box-shadow: none;
    font-size: 14px;
    margin-left: 35px;
}

.chat-container .contentimage {
    max-width: 60vw;
    display: inline-block;
    box-shadow: none;
    font-size: 14px;
    margin-left: 35px;
    word-wrap: break-word;
}

.templatestyle {
    margin-right: 10px;
    border-radius: 6px;
    /*width: 35vw !important;*/
    max-width: 70vw;
    display: inline-block;
    box-shadow: none;
    font-size: 14px;
    margin-left: 35px;
    word-wrap: break-word;
}

.scrolling-wrapper-template {
    display: flex;
    overflow-x: auto;
}

.scrolling-wrapper-template::-webkit-scrollbar {
    height: 10px;
    width: 8px;
    cursor: pointer;
}

.scrolling-wrapper-template::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: rgba(0, 0, 0, .1);
}

.chat-container .contentfile {
    padding: 10px;
    background-color: var(--Chat-ChatboxBackgroundOther) !important;
    border-radius: var(--Chat-ChatboxBorderRadiusOther);
    border: var(--Chat-ChatboxBorderOther) !important;
    border-radius: 10px;
    display: inline-block;
    box-shadow: none;
    max-width: 60vw;
    min-width: 60vw;
    word-wrap: break-word;
    font-size: 14px;
    margin-left: 35px;
}

.chat-container .contentcontact {
  padding: 10px;
  background-color: var(--Chat-ChatboxBackgroundOther) !important;
  border-radius: var(--Chat-ChatboxBorderRadiusOther);
  border: var(--Chat-ChatboxBorderOther) !important;
  border-radius: 10px;
  display: inline-block;
  box-shadow: none;
  max-width: 60vw;
  min-width: 60vw;
  word-wrap: break-word;
  font-size: 14px;
  margin-left: 35px;
}
.chat-container .contentfile .iconFile {
    color: #1569bb;
    font-size: 60px;
    margin-right: 10px;
}

.chat-container .contentcontact .iconContact {
    color: #1569bb;
    font-size: 16px;
    margin-right: 10px;
}

.modalc {
    display: none;
    /* Hidden by default */
    position: fixed;
    /* Stay in place */
    z-index: 1;
    /* Sit on top */
    left: 0;
    top: 0;
    width: 100vw;
    /* Full width */
    height: 100vh;
    /* Full height */
    overflow: hidden;
    background-color: rgba(0, 0, 0, 0.9);
    /* Black w/ opacity */
}

.modal-contentc {
    padding-top: 10vh;
    margin: auto;
    display: block;
    max-width: 95%;
    max-height: 80%;
}

#headcaption {
    margin: auto;
    display: block;
    text-align: left;
    color: #fff;
    padding-top: 1vh;
    padding-bottom: 1vh;
    background-color: var(--Chat-HeaderPictureBorderRadius) !important;
}

.typingbox-button {
    font-size: 20px;
    color: var(--Chat-TypingboxColor) !important;
}

.typingbox-button-send {
    color: var(--Chat-TypingboxColor) !important;
    font-size: 20px !important;
    margin: 5px;
}

.typer-richmenu {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  bottom: 0;
  height: 60px !important;
  width: 100%;
  overflow: hidden;
  background: var(--Chat-TypingboxBackground) !important;
  box-shadow: none;
  justify-content: center;
  bottom: 0;
  position: fixed;
}
.typer-richmenu-show {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  bottom: 0;
  height: 300px !important;
  width: 100%;
  overflow: hidden;
  background: var(--Chat-TypingboxBackground) !important;
  box-shadow: none;
  justify-content: center;
  bottom: 0;
  position: fixed;
}

.typer {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    bottom: 0;
    height: 75px;
    width: 100%;
    background: var(--Chat-TypingboxBackground) !important;
    box-shadow: none;
    justify-content: center;
    padding-left: 10px;
    padding-right: 10px;
}


.typer .v-text-field {
    width: 100%;
    background-color: transparent !important;
    border: none;
    outline: none;
    font-size: 1.25rem;
}

.typer-menu {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    bottom: 0;
    height: 75px !important;
    width: 100%;
    background: var(--Chat-TypingboxBackground) !important;
    box-shadow: none;
    justify-content: center;
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 10px;
    color: var(--Chat-TypingboxColor) !important;
}
.typer-menu-forward {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  bottom: 0;
  height: 75px !important;
  width: 100%;
  background: var(--Chat-Background) !important;
  box-shadow: none;
  justify-content: center;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 10px;
  color: var(--Chat-HeaderBackground) !important;
  border-top-style: solid;
  border-top-width: thin;
}
>>>.v-text-field--solo input {
    margin: auto !important;
}

>>>.theme--light.v-text-field--solo>.v-input__control>.v-input__slot:hover {
    border: none !important;
    border-radius: 37px !important;
    background: white !important;
    font-size: 14px;
    /* width: 70vw; */
    margin: 0px;
}

>>>.theme--light.v-text-field--solo>.v-input__control>.v-input__slot {
    border: 0 !important;
    border-radius: 37px !important;
    background: white !important;
    font-size: 14px;
    /* width: 65vw; */
    box-shadow: none !important;
    margin: 0px;
}
</style>
